(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[77002],{

/***/ 29761:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/take-back",
      function () {
        return __webpack_require__(40565);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31567);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66037);
/* harmony import */ var _material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51115);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41107);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94455);








function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        root: {
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[1]
        },
        button: _defineProperty({
            margin: theme.spacing(0, 0.5),
            display: 'inline-block',
            color: theme.palette.common.white
        }, theme.breakpoints.down('md'), {
            margin: theme.spacing(0.25)
        }),
        questionWrapper: {
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'row',
            width: '100%',
            padding: theme.spacing(2),
            marginBottom: theme.spacing(3),
            border: '1px solid transparent',
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.common.black,
            textTransform: 'none',
            '& .MuiButton-label>* ': {
                margin: 0
            }
        },
        questionWrapperExp: {
            boxShadow: 'none',
            marginBottom: 0,
            borderBottom: 0,
            borderRadius: "".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0 0"),
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            '&:hover': {
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.main
            }
        },
        answer: {
            textAlign: 'left',
            border: "1px solid ".concat(theme.palette.primary.main),
            borderRadius: "0 0 ".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px"),
            marginBottom: theme.spacing(3),
            padding: theme.spacing(3),
            '& .MuiCollapse-wrapperInner>*': {
                margin: theme.spacing(0, 0, 1),
                '&:last-child': {
                    marginBottom: 0
                }
            }
        },
        dropButton: {
            padding: 5,
            height: 35,
            width: 35,
            borderRadius: '50%',
            border: "1px solid ".concat(theme.extraColors.greyLight),
            transition: 'transform .25s ease-in-out'
        },
        dropButtonDown: {
            color: theme.palette.primary.main
        },
        dropButtonUp: {
            color: theme.palette.common.white,
            transform: 'rotate(180deg)'
        }
    });
});
var FaqQuestion = function(param) {
    var question = param.question, answer = param.answer, questionId = param.questionId, handleExpandClick = param.handleExpandClick, isExpanded = param.isExpanded, cat = param.cat, close_others = param.close_others;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)().t;
    var classes = useStyles();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), simpleExpand = ref[0], setSimpleExpand = ref[1];
    var handleExpandClickSimple = function() {
        setSimpleExpand(!simpleExpand);
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)('faq', classes.root),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                variant: "body1",
                component: "h3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    onClick: close_others ? function() {
                        return handleExpandClick(questionId, cat);
                    } : handleExpandClickSimple,
                    "aria-expanded": close_others ? isExpanded : simpleExpand,
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)('faq__question', classes.questionWrapper, !(close_others ? isExpanded : simpleExpand) ? classes.questionWrapper : classes.questionWrapperExp),
                    color: "primary",
                    size: "small",
                    disableRipple: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                            data: question,
                            defaultText: t('texts:general:add_a_text')
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)('faq__btn', classes.dropButton, !(close_others ? isExpanded : simpleExpand) ? classes.dropButtonDown : classes.dropButtonUp)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                in: close_others ? isExpanded : simpleExpand,
                timeout: 0,
                mountOnEnter: true,
                unmountOnExit: true,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)('faq__answer', classes.answer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    data: answer,
                    defaultText: t('texts:general:add_a_text')
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqQuestion);


/***/ }),

/***/ 78709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36456);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73637);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86010);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41107);
/* harmony import */ var _Commitment_Commitment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88737);
/* harmony import */ var _hooks_useAddress__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59361);
/* harmony import */ var _Information_AddressForm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12907);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94455);










function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        loginFormCard: _defineProperty({
            background: theme.palette.common.white,
            padding: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            width: '100%'
        }),
        invite: {
            margin: theme.spacing(4, 0)
        },
        form: {
            width: '70%',
            margin: 'auto'
        },
        smallSpace: {
            marginBottom: theme.spacing(2)
        },
        underline: {
            textDecoration: 'underline',
            cursor: 'pointer'
        },
        marginBottom: {
            marginBottom: theme.spacing(2)
        }
    });
});
var mapStateToProps = function(state) {
    return {
        user: state.user
    };
};
var ConnectedForm = function(param) {
    var switchForm = param.switchForm, text = param.text, userFirstName = param.userFirstName, onSubmit = param.onSubmit, user = param.user, t = param.t, hasAddress = param.hasAddress, _isTakeBack = param.isTakeBack, isTakeBack = _isTakeBack === void 0 ? false : _isTakeBack, funnel = param.funnel;
    var ref4, ref1, ref2;
    var classes = useStyles();
    var ref3 = (0,_hooks_useAddress__WEBPACK_IMPORTED_MODULE_5__/* .useAddress */ .S)('shipping'), address = ref3.address, resetInputAddress = ref3.resetInputAddress;
    var commitmentOnLogin = text === null || text === void 0 ? void 0 : text.is_displayed_on_login;
    var noAddress = (hasAddress === null || hasAddress === void 0 ? void 0 : hasAddress.address) !== undefined && Object.keys(hasAddress.address).length === 0 && hasAddress.address.constructor === Object;
    var isSubscription =  false || "date_to_date" === 'classic_subscription';
    var submitConnectedData = function() {
        if (noAddress) {
            onSubmit(address.payload);
        } else {
            var ref;
            onSubmit(user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.address);
        }
        resetInputAddress();
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        in: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes.loginFormCard,
            children: [
                noAddress && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            container: true,
                            spacing: 1,
                            className: classes.marginBottom,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    variant: 'h4',
                                    align: "center",
                                    children: [
                                        userFirstName,
                                        ', ',
                                        (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.address_required, t('texts:account:address_required'))
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Information_AddressForm__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            account: isTakeBack,
                            addressType: "shipping",
                            hideAdditionalAddress: funnel === null || funnel === void 0 ? void 0 : (ref4 = funnel.data) === null || ref4 === void 0 ? void 0 : ref4.hide_additional_address
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    container: true,
                    justify: "center",
                    children: noAddress && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        variant: 'contained',
                        color: 'primary',
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(classes.smallSpace, 'connected-form__button'),
                        onClick: submitConnectedData,
                        "data-testid": 'Buttoncontinue',
                        disabled: !address.isValid,
                        children: t('texts:account:continue')
                    })
                }),
                !isSubscription && !isTakeBack && (text === null || text === void 0 ? void 0 : text.is_display_guest_link) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes.invite,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        variant: 'body2',
                        color: 'textSecondary',
                        align: "center",
                        className: classes.underline,
                        onClick: function() {
                            return switchForm(2);
                        },
                        children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.guest_link, t('texts:account:guest_link'))
                    })
                }),
                !isTakeBack && commitmentOnLogin && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: 'commitment__area',
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Commitment_Commitment__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        icon: (text === null || text === void 0 ? void 0 : (ref1 = text.protected_data_image) === null || ref1 === void 0 ? void 0 : ref1.url) ? text === null || text === void 0 ? void 0 : (ref2 = text.protected_data_image) === null || ref2 === void 0 ? void 0 : ref2.url : null,
                        title: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.title_data, t('texts:account:title_data')),
                        desc: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.text_data, t('texts:account:text_data')),
                        center: false
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .connect */ .$j)(mapStateToProps)(ConnectedForm));


/***/ }),

/***/ 40565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ take_back; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./components/Layout/Layout.tsx
var Layout = __webpack_require__(8122);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
;// CONCATENATED MODULE: ./components/TakeBack/TakeBack.style.tsx

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var ANSWER_WIDTH_M = 120;
var ANSWER_WIDTH_D = 160;
var REF_IMG_M = 120;
var REF_IMG_D = 210;
var INPUT_WIDTH = 342;
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4;
    return (0,createStyles/* default */.Z)({
        root: {
            backgroundColor: theme.extraColors.greyLight,
            padding: theme.spacing(8, 0, 9),
            minHeight: '70vh'
        },
        center: {
            textAlign: 'center'
        },
        container: {},
        content: _defineProperty({
            minHeight: '50vh',
            margin: 'auto',
            padding: theme.spacing(2),
            borderRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.common.white
        }, theme.breakpoints.up('lg'), {
            maxWidth: 1035,
            padding: theme.spacing(4, 4, 2)
        }),
        takeBackHeaderContent: {
            marginBottom: theme.spacing(2)
        },
        takeBackHeaderTitle: _defineProperty({
            color: theme.palette.primary.main
        }, theme.breakpoints.down('sm'), {
            fontSize: theme.typography.h3.fontSize
        }),
        takeBackHeaderText: {
            color: theme.extraColors.greyMedium,
            '&>p': {
                '&>a': {
                    color: theme.extraColors.greyMedium,
                    textDecoration: 'underline'
                }
            }
        },
        backLink: {
            color: theme.extraColors.greyText,
            marginBottom: theme.spacing(2),
            display: 'inline-flex',
            alignItems: 'center',
            padding: 0,
            textTransform: 'inherit',
            fontSize: '90%',
            '&:hover, &:focus': {
                background: 'none',
                color: theme.palette.common.black
            }
        },
        backArrow: {
            fontSize: '1rem',
            marginRight: theme.spacing(1)
        },
        takeBackBoxContainer: {
            minHeight: 200,
            gap: theme.spacing(2)
        },
        takebackNav: (_obj = {
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: theme.spacing(2),
            listStyle: 'none',
            padding: 0,
            whiteSpace: 'nowrap',
            '&>li': {
                display: 'inline-flex',
                alignItems: 'center'
            }
        }, _defineProperty(_obj, theme.breakpoints.down('sm'), {
            marginBottom: theme.spacing(4),
            fontSize: '75%'
        }), _defineProperty(_obj, theme.breakpoints.up('md'), {
            maxWidth: '75%',
            margin: theme.spacing(0, 'auto', 5),
            position: 'relative',
            fontSize: theme.typography.body1.fontSize,
            '&:after': {
                content: '""',
                display: 'block',
                height: 1,
                position: 'absolute',
                transform: 'translateY(-50%)',
                top: '50%',
                left: theme.spacing(1),
                right: theme.spacing(1),
                background: theme.extraColors.greyMedium
            }
        }), _obj),
        separator: {
            display: 'none'
        },
        stepNumber: {
            display: 'inline-flex',
            justifyContent: 'center',
            textAlign: 'center',
            alignItems: 'center',
            width: '2.5ch',
            height: '2.5ch',
            letterSpacing: 0,
            minWidth: 20,
            minHeight: 20,
            padding: 0,
            margin: theme.spacing(0.5),
            borderRadius: '50%',
            lineHeight: 1,
            fontWeight: 700,
            background: theme.extraColors.greyText,
            color: theme.palette.common.white
        },
        listItem: _defineProperty({
            position: 'relative'
        }, theme.breakpoints.up('md'), {
            position: 'relative',
            zIndex: 1,
            padding: theme.spacing(0, 1),
            background: theme.palette.common.white
        }),
        active: {
            '&>b': {
                backgroundColor: theme.palette.common.black
            }
        },
        faqSection: _defineProperty({
            margin: theme.spacing(5, 0)
        }, theme.breakpoints.up('lg'), {
            margin: theme.spacing(5, 0)
        }),
        faqTitle: {
            marginBottom: theme.spacing(2)
        },
        faqList: {
            margin: 0,
            padding: 0,
            listStyle: 'none'
        },
        firstStepTextRequired: {
            fontSize: theme.typography.h6.fontSize,
            color: theme.extraColors.greyMedium
        },
        firstStepFirstPartContainer: _defineProperty({
            margin: 'auto',
            gap: theme.spacing(2),
            maxWidth: theme.breakpoints.width('md')
        }, theme.breakpoints.up('lg'), {}),
        preliminaryQuestionTitle: {},
        preliminaryQuestion: _defineProperty({}, theme.breakpoints.down('md'), {}),
        preliminaryQuestionCol: {
            flex: 1
        },
        preliminaryQuestionText: {
            '& .paragraph-class': {
                margin: 0,
                display: 'inline'
            }
        },
        preliminaryQuestionRequired: {},
        preliminaryQuestionAnswer: (_obj1 = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            flex: "0 0 ".concat(ANSWER_WIDTH_D, "px")
        }, _defineProperty(_obj1, theme.breakpoints.down('md'), {
            flex: "0 0 ".concat(ANSWER_WIDTH_M, "px")
        }), _defineProperty(_obj1, '& .MuiFormControlLabel-root', {
            margin: 0
        }), _defineProperty(_obj1, '& .MuiFormGroup-root', _defineProperty({
            gap: theme.spacing(3)
        }, theme.breakpoints.down('md'), {
            gap: theme.spacing(1)
        })), _defineProperty(_obj1, '& .MuiRadio-root', {
            padding: theme.spacing(0, 0.25)
        }), _obj1),
        error: {
            display: 'flex',
            alignItems: 'center',
            borderRadius: theme.shape.borderRadius,
            background: theme.palette.error.main,
            color: theme.palette.common.white,
            '&>svg': {
                marginRight: theme.spacing(3)
            },
            '& p': {
                marginTop: 0,
                marginBottom: theme.spacing(2),
                '&:last-child': {
                    marginBottom: 0
                }
            }
        },
        preliminaryQuestionsError: {
            display: 'block',
            padding: theme.spacing(2),
            margin: theme.spacing(4, 0)
        },
        buttonNextPart: {},
        layoutFirstStepSecondPart: _defineProperty({
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(4)
        }, theme.breakpoints.down('md'), {
            flexDirection: 'column',
            gap: theme.spacing(3)
        }),
        layoutFirstStepSecondPartPending: {
            marginLeft: 'auto',
            marginRight: 'auto',
            maxWidth: INPUT_WIDTH
        },
        // test other arrangements
        firstPartContainer: _defineProperty({
            display: 'flex',
            gap: theme.spacing(18),
            justifyContent: 'space-between'
        }, theme.breakpoints.down('md'), {
            //flexDirection: 'column-reverse',
            gap: theme.spacing(8),
            display: 'block'
        }),
        referenceContainer: _defineProperty({
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
        }, theme.breakpoints.down('xs'), {
            minWidth: '100%'
        }),
        searchRefContainer: (_obj2 = {
            display: 'flex',
            gap: theme.spacing(4),
            alignItems: 'center',
            flexDirection: 'column'
        }, _defineProperty(_obj2, theme.breakpoints.down('sm'), {
            gap: theme.spacing(2),
            flexDirection: 'column',
            alignItems: 'center'
        }), _defineProperty(_obj2, theme.breakpoints.down('xs'), {
            alignItems: 'stretch',
            minWidth: '100%'
        }), _obj2),
        loaderContainer: {
            display: 'flex',
            width: '100%',
            justifyContent: 'center'
        },
        searchRefInput: {
            display: 'flex',
            flexDirection: 'column',
            '& .paragraph-class': {
                margin: 0
            }
        },
        searchRefInputSuccess: {},
        searchRefBtn: {
            marginBottom: "calc(".concat(theme.typography.caption.fontSize, "px + ").concat(theme.spacing(1), "px)")
        },
        referenceNumberError: _defineProperty({
            display: 'inline-flex',
            width: '100%',
            padding: theme.spacing(1, 2)
        }, theme.breakpoints.down('md'), {
            marginTop: theme.spacing(1)
        }),
        selectContainer: (_obj3 = {
            display: 'flex',
            flexWrap: 'wrap',
            gap: theme.spacing(2),
            width: '100%'
        }, _defineProperty(_obj3, theme.breakpoints.up('md'), {
            marginTop: theme.spacing(4)
        }), _defineProperty(_obj3, theme.breakpoints.down('md'), {
            marginLeft: 'auto',
            marginRight: 'auto'
        }), _obj3),
        formControl: {
            minWidth: 120,
            width: '100%'
        },
        referenceImage: _defineProperty({
            width: REF_IMG_D
        }, theme.breakpoints.down('md'), {
            marginLeft: 'auto',
            marginRight: 'auto',
            margin: theme.spacing(4, 'auto', 0)
        }),
        imageSize: {
            width: '100%',
            objectFit: 'contain'
        },
        referenceImageTitle: {
            margin: theme.spacing(2, 0),
            textAlign: 'center'
        },
        label: {
            display: 'block',
            cursor: 'pointer',
            textAlign: 'inherit',
            marginBottom: theme.spacing(0.5),
            fontSize: 11,
            '& .paragraph-class': {
                margin: 0
            }
        },
        labelAutoComplete: {
            display: 'block',
            cursor: 'pointer',
            textAlign: 'inherit',
            fontSize: 11,
            paddingLeft: theme.spacing(1.25),
            marginBottom: theme.spacing(0.5)
        },
        selector: {
            padding: theme.spacing(0.5, 2, 0.5, 1),
            height: 38,
            borderRadius: theme.shape.borderRadius,
            border: 'none',
            boxShadow: theme.shadows[1],
            fontSize: 12,
            backgroundColor: theme.palette.common.white,
            color: theme.palette.common.black
        },
        selectorPlaceholder: {
            color: theme.extraColors.greyMedium
        },
        helpGrid: {
            alignItems: 'center'
        },
        helpLink: (_obj4 = {
            justifyContent: 'start',
            padding: theme.spacing(0, 0, 0, 0.6),
            fontSize: theme.typography.caption.fontSize,
            textDecoration: 'underline',
            textTransform: 'inherit',
            color: theme.palette.common.black
        }, _defineProperty(_obj4, theme.breakpoints.down('md'), {
            marginBottom: theme.spacing(1)
        }), _defineProperty(_obj4, '&:hover, &:focus', {
            background: 'none'
        }), _obj4),
        states: {
            marginBottom: theme.spacing(2),
            paddingBottom: theme.spacing(2),
            borderBottom: "1px solid ".concat(theme.extraColors.greyLight),
            alignItems: 'center',
            '& .MuiFormControlLabel-label': {
                marginLeft: theme.spacing(2)
            }
        },
        statesForm: {},
        statesDefinitions: {
            color: theme.extraColors.greyText,
            marginLeft: theme.spacing(5)
        },
        marginBottom: {
            marginBottom: theme.spacing(2)
        },
        takeBackSecondStepContainer: {
            maxWidth: theme.breakpoints.width('md'),
            margin: 'auto'
        },
        takeBackSecondStep: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2)
        },
        productItem: _defineProperty({
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: theme.spacing(2),
            gap: theme.spacing(7)
        }, theme.breakpoints.down('md'), {
            gap: theme.spacing(3)
        }),
        productName: {
            marginBottom: theme.spacing(1),
            paddingRight: theme.spacing(3)
        },
        productMeta: {
            marginBottom: theme.spacing(1)
        },
        productImage: {
            flex: "0 0 ".concat(REF_IMG_M, "px")
        },
        productDetails: _defineProperty({
            position: 'relative',
            flex: 1,
            gap: theme.spacing(4)
        }, theme.breakpoints.down('md'), {
            gap: theme.spacing(2)
        }),
        productDescription: {},
        productPrice: {},
        productDelete: {
            padding: 0,
            minWidth: 0,
            position: 'absolute',
            top: 0,
            right: 0,
            '&:hover, &:focus': {
                background: 'none'
            }
        },
        productStatePrice: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        totalContainer: _defineProperty({
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            gap: theme.spacing(1)
        }),
        totalPrice: {
            display: 'flex',
            alignItems: 'baseline',
            fontWeight: 700
        },
        takeBackOffer: {
            '& p': {
                margin: 0
            }
        },
        SecondStepButton: {
            alignSelf: 'center'
        },
        validAddress: {
            display: 'flex',
            justifyContent: 'center'
        },
        price: {
            fontWeight: 700
        },
        locationContainer: _defineProperty({
            display: 'flex',
            flexDirection: 'column',
            paddingTop: theme.spacing(2)
        }, theme.breakpoints.up('md'), {
            paddingTop: theme.spacing(6)
        }),
        locationTitleContainer: {
            marginBottom: theme.spacing(2)
        },
        locationTitle: {
            fontSize: theme.typography.h5.fontSize
        },
        locationDesc: {
            '& p': {
                margin: 0
            }
        },
        formLabelRow: {
            marginBottom: theme.spacing(1),
            '& .MuiFormControlLabel-root': {
                display: 'flex',
                gap: theme.spacing(1),
                margin: 0
            },
            '& .paragraph-class': {
                margin: 0
            }
        },
        location: {
            display: 'flex'
        },
        takeBackThirdStep: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 300,
            gap: theme.spacing(2),
            marginTop: theme.spacing(5)
        },
        confirmationIcon: {
            '&>svg': {
                fontSize: 60,
                color: theme.palette.success.main
            }
        },
        confirmationText: _defineProperty({
            '&>h3': {
                marginTop: 0,
                fontSize: theme.typography.h3.fontSize
            },
            padding: theme.spacing(3, 0, 3)
        }, theme.breakpoints.up('md'), {
            padding: theme.spacing(2, 6, 2),
            maxWidth: theme.breakpoints.width('md'),
            textAlign: 'center'
        }),
        section: {
            padding: theme.spacing(0, 0, 3)
        },
        takeBackSecondStepSubmit: _defineProperty({
            padding: theme.spacing(1, 0, 0)
        }, theme.breakpoints.up('md'), {
            padding: theme.spacing(6, 0, 4)
        }),
        myCustomHits: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 16,
            marginTop: 20
        },
        myCustomHit: {
            flex: '1 1 calc(33.333% - 16px)',
            boxSizing: 'border-box',
            border: '1px solid #ddd',
            padding: 16,
            borderRadius: 8,
            textAlign: 'center',
            '&>img': {
                width: '100%',
                height: 'auto',
                maxWidth: 150,
                marginBottom: 8
            }
        },
        itemLink: {
            display: 'flex',
            alignItems: 'center',
            padding: '10px',
            border: '1px solid #ddd',
            borderRadius: '8px',
            textDecoration: 'none',
            color: 'inherit',
            '&:hover': {
                backgroundColor: '#f0f0f0'
            }
        },
        itemRoot: {
            display: 'flex',
            flexDirection: 'row'
        },
        itemContent: {
            display: 'flex',
            flexDirection: 'column',
            marginLeft: '16px'
        },
        itemIcon: {
            '& img': {
                width: '50px',
                height: '50px',
                objectFit: 'cover',
                borderRadius: '4px'
            }
        },
        itemTitle: {
            fontSize: '16px',
            fontWeight: 'bold',
            marginBottom: '4px'
        },
        itemLabelReference: {
            fontSize: '11px'
        },
        itemCategory: {
            fontSize: '14px',
            color: '#555'
        },
        input: {
            display: 'block',
            padding: theme.spacing(1, 1.25),
            fontFamily: theme.typography.fontFamily,
            width: '100%',
            fontSize: 14,
            borderRadius: theme.spacing(0.75),
            border: "1px solid ".concat(theme.extraColors.greyLight),
            color: theme.typography.body1.color,
            backgroundColor: theme.extraColors.greyLight,
            WebkitAppearance: 'none',
            '&::placeholder': {
                opacity: 0.75,
                color: theme.typography.body1.color
            },
            '&:disabled': {
                userSelect: 'none',
                cursor: 'not-allowed'
            },
            '& textarea': {
                fontFamily: theme.typography.fontFamily,
                color: theme.typography.body1.color,
                fontSize: 14
            }
        },
        countrySelector: {
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(0.5, 2, 0.5, 1),
            backgroundColor: theme.extraColors.greyLight,
            minWidth: 200,
            color: theme.palette.common.black,
            height: 40,
            border: 'none'
        },
        parcelNumberContainer: {
            margin: '2rem auto',
            '& .label': {
                maxWidth: 'none',
                fontSize: '1.25rem',
                marginBottom: theme.spacing(2)
            }
        },
        parcelNumberButton: {
            marginTop: theme.spacing(3)
        }
    });
});
/* harmony default export */ var TakeBack_style = (useStyles);

// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
;// CONCATENATED MODULE: ./components/TakeBack/TakeBackBox.tsx






var TakeBackBox = function(param) {
    var children = param.children, activeStep = param.activeStep, t = param.t, data = param.data, hideStep2 = param.hideStep2, additionalEditParcelNumberStep = param.additionalEditParcelNumberStep;
    var classes = TakeBack_style();
    var array = additionalEditParcelNumberStep ? [
        0,
        1,
        2,
        3
    ] : [
        0,
        1,
        2
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        variant: "body1",
        component: "div",
        className: classes.takeBackBoxContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                className: (0,clsx_m/* default */.Z)('takeBack__nav', classes.takebackNav),
                id: "takeBack__nav",
                children: array.map(function(index) {
                    if (hideStep2) {
                        if (index === 1 && !additionalEditParcelNumberStep) {
                            return null;
                        }
                        if (index === 2 && additionalEditParcelNumberStep) {
                            return null;
                        }
                    }
                    var isActive = index === activeStep;
                    var humanIndex = index + 1;
                    var defaultText = "texts:takeBack:step_".concat(humanIndex);
                    var cmsText = "take_back_title_step_".concat(humanIndex);
                    var renderedIndex = humanIndex;
                    if (additionalEditParcelNumberStep) {
                        if (index === 1) {
                            defaultText = 'texts:takeBack:step_edit_parcel_number';
                            cmsText = 'take_back_title_step_edit_parcel_number';
                            renderedIndex = 2;
                        }
                        if (index > 1) {
                            defaultText = "texts:takeBack:step_".concat(humanIndex - 1);
                            cmsText = "take_back_title_step_".concat(humanIndex - 1);
                            renderedIndex = humanIndex - 1;
                        }
                    }
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            index > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                "aria-hidden": "true",
                                className: (0,clsx_m/* default */.Z)(classes.separator, 'takeBack__nav__separator'),
                                children: "|"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: (0,clsx_m/* default */.Z)('takeBack__nav__item', isActive && [
                                    classes.active,
                                    'takeBack__nav__item--active'
                                ], classes.listItem),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        className: (0,clsx_m/* default */.Z)('takeBack__nav__step', classes.stepNumber, isActive && 'takeBack__nav__step--active'),
                                        children: renderedIndex
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (0,clsx_m/* default */.Z)('takeBack__nav__label'),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            defaultText: t(defaultText),
                                            data: data && data[cmsText]
                                        })
                                    })
                                ]
                            }, index)
                        ]
                    }));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)('takeBack-box__content'),
                children: children
            })
        ]
    }));
};
/* harmony default export */ var TakeBack_TakeBackBox = (TakeBackBox);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/KeyboardBackspace.js
var KeyboardBackspace = __webpack_require__(64379);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
;// CONCATENATED MODULE: ./components/TakeBack/TakeBackHeader.tsx








var TakeBackHeader = function(param) {
    var settings = param.settings, handlePrevStep = param.handlePrevStep, t = param.t, activeStep = param.activeStep, show = param.show;
    var ref, ref1, ref2;
    var classes = TakeBack_style();
    var title = settings === null || settings === void 0 ? void 0 : (ref = settings.data) === null || ref === void 0 ? void 0 : ref.take_back_main_title;
    var text = settings === null || settings === void 0 ? void 0 : (ref1 = settings.data) === null || ref1 === void 0 ? void 0 : ref1.take_back_text;
    var previousStep = settings === null || settings === void 0 ? void 0 : (ref2 = settings.data) === null || ref2 === void 0 ? void 0 : ref2.previous_step;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)('takeBack__header', classes.takeBackHeaderContent),
        children: [
            (0,CMSText/* isPrismicText */.LT)(title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h2",
                component: "h1",
                className: (0,clsx_m/* default */.Z)('takeBack__header__title', classes.takeBackHeaderTitle),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    asText: true,
                    data: title,
                    defaultText: t('texts:takeBack:title')
                })
            }),
            (0,CMSText/* isPrismicText */.LT)(text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body1",
                component: "div",
                className: (0,clsx_m/* default */.Z)('takeBack__header__text', classes.takeBackHeaderText),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    data: text,
                    defaultText: t('texts:takeBack:text')
                })
            }),
            (activeStep === 1 || activeStep === 0 && !show) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                variant: "text",
                className: (0,clsx_m/* default */.Z)('takeBack__back-btn', classes.backLink),
                onClick: function() {
                    return handlePrevStep();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardBackspace/* default */.Z, {
                        className: classes.backArrow
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: previousStep,
                        defaultText: t('texts:takeBack:previous_step')
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var TakeBack_TakeBackHeader = (TakeBackHeader);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Error.js
var Error = __webpack_require__(72063);
// EXTERNAL MODULE: ./components/TextField/TextField.tsx + 1 modules
var TextField = __webpack_require__(59000);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(29525);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Cancel.js
var Cancel = __webpack_require__(47298);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/HelpOutlineOutlined.js
var HelpOutlineOutlined = __webpack_require__(54994);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Slide/Slide.js
var Slide = __webpack_require__(82285);
;// CONCATENATED MODULE: ./components/TakeBack/ReferenceModal.tsx








function ReferenceModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ReferenceModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ReferenceModal_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        dialog: {
            gap: theme.spacing(2),
            '& .MuiDialog-paperWidthSm': ReferenceModal_defineProperty({}, theme.breakpoints.up('lg'), {
                maxWidth: theme.breakpoints.width('md')
            }),
            '& .MuiPaper-root': {
                backgroundColor: 'inherit'
            }
        },
        dialogHeader: {
            display: 'inline-flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginBottom: theme.spacing(2),
            color: theme.palette.common.white
        },
        cross: {
            cursor: 'pointer',
            height: 37,
            width: 37,
            padding: theme.spacing(0.5),
            color: theme.palette.common.white
        },
        dialogContent: ReferenceModal_defineProperty({
            backgroundColor: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(3, 5, 2)
        }, theme.breakpoints.down('xs'), {
            padding: theme.spacing(1)
        }),
        dialogTitle: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: theme.spacing(0, 0, 2),
            color: theme.palette.primary.main,
            '& .paragraph-class': {
                margin: 0
            }
        },
        referenceImg: {
            display: 'block',
            maxWidth: '100%',
            height: 'auto',
            margin: 'auto',
            marginBottom: theme.spacing(2)
        },
        modalText: {}
    });
});
var Transition = /*#__PURE__*/ react.forwardRef(function Transition(props, ref) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, _objectSpread({
        direction: "up",
        ref: ref
    }, props)));
});
var ReferenceModal = function(param) {
    var open = param.open, handleClose = param.handleClose, t = param.t, takeBackData = param.takeBackData;
    var modalClasses = ReferenceModal_useStyles();
    var theme = (0,useTheme/* default */.Z)();
    var fullScreen = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('xs'));
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        fullScreen: fullScreen,
        open: open,
        onClose: handleClose,
        TransitionComponent: Transition,
        className: (0,clsx_m/* default */.Z)('takeBack-dialog', modalClasses.dialog),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
            className: (0,clsx_m/* default */.Z)('takeBack-dialog__content', modalClasses.dialogContent),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)('takeBack-dialog__header', modalClasses.dialogHeader),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h4",
                            className: "takeBack-dialog__header__close-text",
                            children: t('texts:takeBack:close_modal')
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cancel/* default */.Z, {
                            onClick: handleClose,
                            className: (0,clsx_m/* default */.Z)('takeBack-dialog__header__close-icon', modalClasses.cross)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "h3",
                    component: "h3",
                    className: (0,clsx_m/* default */.Z)('takeBack-dialog__title', modalClasses.dialogTitle),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpOutlineOutlined/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                data: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.reference_number_explication_title,
                                defaultText: t('texts:takeBack:reference_number_link')
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    component: "div",
                    className: (0,clsx_m/* default */.Z)('takeBack-dialog__wysiwyg', modalClasses.modalText),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        data: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.reference_number_explication_text,
                        defaultText: t()
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var TakeBack_ReferenceModal = (ReferenceModal);

;// CONCATENATED MODULE: ./components/TakeBack/StatesModal.tsx








function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function StatesModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function StatesModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            StatesModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var StatesModal_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        dialog: {},
        dialogContent: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(3),
            textAlign: 'center',
            padding: theme.spacing(2, 6, 6, 6)
        },
        dialogHeader: {
            display: 'inline-flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            color: theme.palette.common.white
        },
        cross: {
            cursor: 'pointer',
            height: 37,
            width: 37,
            padding: theme.spacing(0.5),
            color: theme.palette.common.white
        },
        statesContainer: {},
        stateTitle: {
            paddingBottom: theme.spacing(1.25)
        },
        stateDescription: {},
        stateRefusedTitle: {
            borderTop: '1px solid black',
            paddingTop: theme.spacing(1.25)
        },
        stateRefusedDescription: {}
    });
});
var StatesModal_Transition = /*#__PURE__*/ react.forwardRef(function Transition(props, ref) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, StatesModal_objectSpread({
        direction: "up",
        ref: ref
    }, props)));
});
var StatesModal = function(param1) {
    var open = param1.open, handleClose = param1.handleClose, takeBackData = param1.takeBackData, entries = param1.entries;
    var modalClasses = StatesModal_useStyles();
    var theme = (0,useTheme/* default */.Z)();
    var fullScreen = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('xs'));
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        fullScreen: fullScreen,
        open: open,
        onClose: handleClose,
        TransitionComponent: StatesModal_Transition,
        className: (0,clsx_m/* default */.Z)('takeBack-dialog__states', modalClasses.dialog),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
            className: (0,clsx_m/* default */.Z)('takeBack-dialog__states__content', modalClasses.dialogContent),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)('takeBack-dialog__header', modalClasses.dialogHeader),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h4",
                            className: "takeBack-dialog__header__close-text",
                            children: t('texts:takeBack:close_modal')
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cancel/* default */.Z, {
                            onClick: handleClose,
                            className: (0,clsx_m/* default */.Z)('takeBack-dialog__header__close-icon', modalClasses.cross)
                        })
                    ]
                }),
                entries.map(function(param) {
                    var _param = _slicedToArray(param, 2), key = _param[0], stateValue = _param[1];
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)(modalClasses.statesContainer),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "h2",
                                variant: "h3",
                                className: (0,clsx_m/* default */.Z)(modalClasses.stateTitle),
                                children: stateValue.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                className: (0,clsx_m/* default */.Z)(modalClasses.stateDescription),
                                children: stateValue.desc
                            })
                        ]
                    }, key));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            component: "div",
                            variant: "h3",
                            className: (0,clsx_m/* default */.Z)(modalClasses.stateRefusedTitle),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                data: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.refusedcondition,
                                defaultText: t('texts:takeBack:refused_state')
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            component: "div",
                            variant: "body2",
                            className: (0,clsx_m/* default */.Z)(modalClasses.stateRefusedDescription),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                data: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.refusedconditiondefinition,
                                defaultText: t('texts:takeBack:refused_state')
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var TakeBack_StatesModal = (StatesModal);

// EXTERNAL MODULE: ./components/ImgKitHandler/ImgKitHandler.tsx
var ImgKitHandler = __webpack_require__(26137);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/autocomplete.js + 69 modules
var autocomplete = __webpack_require__(53870);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@algolia/autocomplete-theme-classic/dist/theme.min.css
var theme_min = __webpack_require__(49747);
;// CONCATENATED MODULE: ./components/Input/AutoComplete.tsx





function AutoComplete_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AutoComplete_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AutoComplete_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Autocomplete = function(props) {
    var containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!containerRef.current) {
            return undefined;
        }
        var search = (0,autocomplete/* autocomplete */.H)(AutoComplete_objectSpread({
            container: containerRef.current,
            detachedMediaQuery: 'none',
            renderer: {
                createElement: react.createElement,
                Fragment: react.Fragment,
                render: react_dom.render,
                placeholder: props.placeholder
            }
        }, props));
        return function() {
            search.destroy();
        };
    }, [
        props
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: containerRef
    }));
};

// EXTERNAL MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/requesters/getAlgoliaResults.js + 4 modules
var getAlgoliaResults = __webpack_require__(84093);
// EXTERNAL MODULE: ./node_modules/algoliasearch/dist/algoliasearch.umd.js
var algoliasearch_umd = __webpack_require__(24955);
var algoliasearch_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_umd);
;// CONCATENATED MODULE: ./components/TakeBack/AutoCompleteTakeBack.tsx









var AutoCompleteTakeBack = function(param1) {
    var showCriterion = param1.showCriterion, label = param1.label, handleCheckProduct = param1.handleCheckProduct, lang = param1.lang;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var classes = TakeBack_style();
    var locale = lang.slice(0, 2) + '_' + lang.slice(3).toUpperCase();
    (0,react.useEffect)(function() {
        showCriterion && (0,utils/* scrollToDiv */.cx)('takeBack__nav');
    }, [
        showCriterion
    ]);
    var ref = (0,react.useState)(''), searchQuery = ref[0], setSearchQuery = ref[1];
    var searchClient = algoliasearch_umd_default()("DLUCYJQLJW", "c6cd2890a7ee0a2e1e6ebd9a6b9a49ab");
    var ProductItem = function(param) {
        var item = param.item, components = param.components, onClick = param.onClick, setQuery = param.setQuery;
        var handleClick = function() {
            onClick(item, setQuery);
            setQuery(item["product_name_".concat(locale)]);
        };
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            onClick: handleClick,
            className: classes.itemRoot,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.itemIcon,
                    children: item.image_path && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: item.image_path,
                        alt: item["product_name_".concat(locale)]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.itemContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.itemTitle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Highlight, {
                                hit: item,
                                attribute: "product_name_".concat(locale)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.itemLabelReference,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Highlight, {
                                hit: item,
                                attribute: 'product_label_reference'
                            })
                        })
                    ]
                })
            ]
        }));
    };
    var handleProductClick = function(item, setQuery) {
        handleCheckProduct(item.product_id);
        setSearchQuery(item["product_name_".concat(locale)]);
        setQuery(item["product_name_".concat(locale)]);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (0,clsx_m/* default */.Z)('label', classes.labelAutoComplete),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete, {
                placeholder: t('texts:general.search_bar.input_placeholder'),
                initialState: {
                    query: searchQuery || ''
                },
                getSources: function(param2) {
                    var query = param2.query, setQuery = param2.setQuery;
                    return [
                        {
                            sourceId: 'products',
                            insights: true,
                            getItems: function getItems() {
                                return (0,getAlgoliaResults/* getAlgoliaResults */.g)({
                                    searchClient: searchClient,
                                    queries: [
                                        {
                                            indexName: "maje_2nde_hand",
                                            query: query,
                                            params: {
                                                filters: 'has_product_label_reference:true'
                                            }
                                        }, 
                                    ]
                                });
                            },
                            templates: {
                                header: function header() {
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}));
                                },
                                item: function item(param) {
                                    var item1 = param.item, components = param.components;
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItem, {
                                        item: item1,
                                        components: components,
                                        onClick: handleProductClick,
                                        setQuery: setQuery
                                    }));
                                }
                            }
                        }, 
                    ];
                },
                classNames: {
                    // documentation to know classNames : https://www.algolia.com/doc/ui-libraries/autocomplete/api-reference/autocomplete-js/autocomplete/#param-classnames
                    form: 'takeback__input_form',
                    input: 'takeback__input'
                }
            })
        ]
    }));
};
/* harmony default export */ var TakeBack_AutoCompleteTakeBack = (AutoCompleteTakeBack);

// EXTERNAL MODULE: ./components/Loader/Loader.tsx
var Loader = __webpack_require__(96149);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog_Dialog = __webpack_require__(50657);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js + 3 modules
var DialogTitle = __webpack_require__(14215);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent_DialogContent = __webpack_require__(6514);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(31425);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button_Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
;// CONCATENATED MODULE: ./components/Dialog/ConfirmationDialog.tsx





var ConfirmationDialog = function(param) {
    var open = param.open, onClose = param.onClose, onConfirm = param.onConfirm, title = param.title, body = param.body, confirmText = param.confirmText, children = param.children, _confirmButtonDisabled = param.confirmButtonDisabled, confirmButtonDisabled = _confirmButtonDisabled === void 0 ? false : _confirmButtonDisabled;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Dialog_Dialog/* default */.Z, {
        open: open,
        onClose: onClose,
        PaperProps: {
            elevation: 0,
            square: true,
            className: 'take-back-confirmation-modal__container'
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogTitle/* default */.Z, {
                className: 'take-back-confirmation-modal__title',
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        data: title,
                        asText: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        className: 'take-back-confirmation-modal__closeButton',
                        onClick: onClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent_DialogContent/* default */.Z, {
                className: 'take-back-confirmation-modal__body',
                children: [
                    body && /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        data: body
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                className: 'take-back-confirmation-modal__actions',
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    className: 'take-back-confirmation-modal__actionButton',
                    onClick: onConfirm,
                    disabled: confirmButtonDisabled,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: confirmText
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Dialog/index.ts


;// CONCATENATED MODULE: ./components/TakeBack/TakeBackFirstStepSecondPart.tsx
















function TakeBackFirstStepSecondPart_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function TakeBackFirstStepSecondPart_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function TakeBackFirstStepSecondPart_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function TakeBackFirstStepSecondPart_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TakeBackFirstStepSecondPart_slicedToArray(arr, i) {
    return TakeBackFirstStepSecondPart_arrayWithHoles(arr) || TakeBackFirstStepSecondPart_iterableToArrayLimit(arr, i) || TakeBackFirstStepSecondPart_unsupportedIterableToArray(arr, i) || TakeBackFirstStepSecondPart_nonIterableRest();
}
function TakeBackFirstStepSecondPart_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return TakeBackFirstStepSecondPart_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return TakeBackFirstStepSecondPart_arrayLikeToArray(o, minLen);
}
var TakeBackFirstStepSecondPart = function(param1) {
    var prismicTakeBack = param1.prismicTakeBack, t = param1.t, onSubmitFirstStep = param1.onSubmitFirstStep, errorReference = param1.errorReference, disabledButtonsecondPart = param1.disabledButtonsecondPart, referenceNumberValue = param1.referenceNumberValue, handleReferenceNumberValue = param1.handleReferenceNumberValue, selectValue = param1.selectValue, handleSelect = param1.handleSelect, productState = param1.productState, handleState = param1.handleState, showCriterion = param1.showCriterion, handleCheckReference = param1.handleCheckReference, handleCheckProduct = param1.handleCheckProduct, takeBack = param1.takeBack, entries = param1.entries, main = param1.main, lang = param1.lang, currentProductIndex = param1.currentProductIndex;
    var ref13, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var classes = TakeBack_style();
    var takeBackData = prismicTakeBack === null || prismicTakeBack === void 0 ? void 0 : prismicTakeBack.data;
    var ref10 = (0,react.useState)(false), openReferenceModal = ref10[0], setOpenReferenceModal = ref10[1];
    var ref11 = (0,react.useState)(false), openStatesModal = ref11[0], setOpenStatesModal = ref11[1];
    var ref12 = (0,react.useState)(null), confirmationDialogState = ref12[0], setConfirmationDialogState = ref12[1];
    var confirmationModalContent = {
        perfectCondition: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.second_confirmation_body_perfect_condition,
        veryGoodCondition: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.second_confirmation_body_very_good_condition,
        goodCondition: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.second_confirmation_body_good_condition
    };
    var selectSizePlaceholder = (0,CMSText/* prismicText */.yz)(takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.select_size_placeholder, t('texts:takeBack:select'));
    var selectStatePlaceholder = (0,CMSText/* prismicText */.yz)(takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.select_state_placeholder, t('texts:takeBack:select'));
    var secondHandSize = takeBack === null || takeBack === void 0 ? void 0 : (ref13 = takeBack.response) === null || ref13 === void 0 ? void 0 : (ref1 = ref13.variants) === null || ref1 === void 0 ? void 0 : ref1.filter(function(variant) {
        return variant.channelPricings.WEB.secondHand;
    });
    var mediumImgWidth = main === null || main === void 0 ? void 0 : (ref2 = main.data) === null || ref2 === void 0 ? void 0 : ref2.medium_image_size;
    var aspectRatio = (0,utils/* thumbnailRatio */.pm)(main === null || main === void 0 ? void 0 : (ref3 = main.data) === null || ref3 === void 0 ? void 0 : ref3.thumbnail_ratio);
    var handleCheckReferenceOnEnter = function(event) {
        if (event === 'Enter') {
            handleCheckReference(referenceNumberValue);
        }
    };
    var submitForm = function(event) {
        event.preventDefault();
    };
    var handleCloseConfirmationDialog = function() {
        setConfirmationDialogState(null);
    };
    var handleStateSelect = function(event) {
        if (takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.show_confirmation) {
            setConfirmationDialogState(event.target.value);
        }
        handleState(event);
    };
    (0,react.useEffect)(function() {
        showCriterion && (0,utils/* scrollToDiv */.cx)('takeBack__nav');
    }, [
        showCriterion
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: (0,clsx_m/* default */.Z)(classes.layoutFirstStepSecondPart, 'takeBack__step', 'takeBack__firstStep', 'takeBack__firstStep--second-part', !showCriterion && [
                    classes.layoutFirstStepSecondPartPending,
                    'takeBack__firstStep--pending', 
                ], showCriterion && 'takeBack__firstStep--success'),
                method: "post",
                onSubmit: submitForm,
                id: "takeBack__firstStep",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: "takeBack-item-title",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.item,
                                defaultText: t('texts:takeBack:item')
                            }),
                            currentProductIndex += 1
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)(classes.firstPartContainer),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.referenceContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)('takeBack-searchRef', classes.searchRefContainer, classes.marginBottom),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,clsx_m/* default */.Z)('takeBack-searchRef__input', classes.searchRefInput, showCriterion && [
                                                    classes.searchRefInputSuccess,
                                                    'takeBack-searchRef__input--success', 
                                                ]),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        (takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.find_product_without_reference) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_AutoCompleteTakeBack, {
                                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    data: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.reference_number_title,
                                                                    defaultText: t('texts:takeBack:reference_number_label')
                                                                }),
                                                                showCriterion: showCriterion,
                                                                handleCheckProduct: handleCheckProduct,
                                                                lang: lang
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                data: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.reference_number_title,
                                                                defaultText: t('texts:takeBack:reference_number_label')
                                                            }),
                                                            name: 'referenceNumber',
                                                            placeholder: (0,CMSText/* prismicText */.yz)(takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.reference_number_placeholder, t('texts:takeBack:reference_number_placeholder')),
                                                            value: referenceNumberValue,
                                                            onChange: handleReferenceNumberValue,
                                                            onKeyPress: handleCheckReferenceOnEnter,
                                                            required: true,
                                                            noMargin: true,
                                                            isSuccessIcon: showCriterion
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                            container: true,
                                                            spacing: 1,
                                                            className: (0,clsx_m/* default */.Z)(classes.helpGrid, 'takeBack__help-grid'),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                    item: true,
                                                                    xs: 6,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        variant: "text",
                                                                        onClick: function() {
                                                                            return setOpenReferenceModal(true);
                                                                        },
                                                                        className: (0,clsx_m/* default */.Z)(classes.helpLink, 'takeBack__help-link'),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                            asText: true,
                                                                            data: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.reference_number_explication_link,
                                                                            defaultText: t('texts:takeBack:reference_number_link')
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                    item: true,
                                                                    xs: 6,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        component: "p",
                                                                        className: (0,clsx_m/* default */.Z)(classes.firstStepTextRequired, 'takeBack__required-field'),
                                                                        align: "right",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                            asText: true,
                                                                            data: prismicTakeBack === null || prismicTakeBack === void 0 ? void 0 : (ref4 = prismicTakeBack.data) === null || ref4 === void 0 ? void 0 : ref4.required_field,
                                                                            defaultText: t('texts:takeBack:required_field')
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            errorReference && /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                                in: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: "body1",
                                                    component: "div",
                                                    className: (0,clsx_m/* default */.Z)('takeBack__error', 'takeBack__error--searchRef', classes.referenceNumberError, classes.error),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {
                                                            color: "inherit",
                                                            fontSize: "small"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                data: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.reference_error,
                                                                defaultText: t('texts:takeBack:reference_error')
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            !(takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.find_product_without_reference) && !showCriterion && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.searchRefBtn,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    size: 'small',
                                                    variant: "contained",
                                                    color: "primary",
                                                    onClick: function() {
                                                        return handleCheckReference(referenceNumberValue);
                                                    },
                                                    className: classes.buttonNextPart,
                                                    disabled: errorReference || referenceNumberValue === '',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.reference_check_button,
                                                        defaultText: t('texts:takeBack:reference_check_button')
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_ReferenceModal, {
                                        open: openReferenceModal,
                                        handleClose: function() {
                                            return setOpenReferenceModal(false);
                                        },
                                        t: t,
                                        takeBackData: takeBackData
                                    }),
                                    (takeBack === null || takeBack === void 0 ? void 0 : takeBack.loading) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classes.loaderContainer,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                                    }),
                                    !(takeBack === null || takeBack === void 0 ? void 0 : takeBack.loading) && showCriterion && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,clsx_m/* default */.Z)(classes.selectContainer, 'takeBack__variant__select'),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                    className: (0,clsx_m/* default */.Z)(classes.formControl, classes.marginBottom),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: (0,clsx_m/* default */.Z)(classes.label, 'takeBack__label', 'takeBack__label--select'),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: prismicTakeBack === null || prismicTakeBack === void 0 ? void 0 : (ref5 = prismicTakeBack.data) === null || ref5 === void 0 ? void 0 : ref5.select_size_label,
                                                                    defaultText: t('texts:takeBack:select_label_size')
                                                                }),
                                                                '*'
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                            value: selectValue,
                                                            className: (0,clsx_m/* default */.Z)(classes.selector, 'takeBack__select', 'takeBack__select--size'),
                                                            onChange: handleSelect,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    value: '',
                                                                    children: selectSizePlaceholder
                                                                }),
                                                                secondHandSize.length > 0 && secondHandSize.map(function(variant, index) {
                                                                    var ref;
                                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: variant.sku,
                                                                        children: variant === null || variant === void 0 ? void 0 : (ref = variant.newSize) === null || ref === void 0 ? void 0 : ref.name
                                                                    }, index));
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (0,clsx_m/* default */.Z)(classes.selectContainer, 'takeBack__state__select'),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                        className: classes.formControl,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                className: (0,clsx_m/* default */.Z)(classes.label, 'takeBack__label', 'takeBack__label--select'),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                        asText: true,
                                                                        data: prismicTakeBack === null || prismicTakeBack === void 0 ? void 0 : (ref6 = prismicTakeBack.data) === null || ref6 === void 0 ? void 0 : ref6.select_state_label,
                                                                        defaultText: t('texts:takeBack:select_label_state')
                                                                    }),
                                                                    '*'
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                                value: productState,
                                                                className: (0,clsx_m/* default */.Z)(classes.selector, 'takeBack__select', 'takeBack__select--state'),
                                                                onChange: handleStateSelect,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: '',
                                                                        children: selectStatePlaceholder
                                                                    }),
                                                                    entries.map(function(param) {
                                                                        var _param = TakeBackFirstStepSecondPart_slicedToArray(param, 2), key = _param[0], stateValue = _param[1];
                                                                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: key,
                                                                            children: stateValue.title
                                                                        }, key));
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                container: true,
                                                                spacing: 1,
                                                                className: (0,clsx_m/* default */.Z)(classes.helpGrid, 'takeBack__help-grid'),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                    item: true,
                                                                    xs: 12,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        variant: "text",
                                                                        onClick: function() {
                                                                            return setOpenStatesModal(true);
                                                                        },
                                                                        className: (0,clsx_m/* default */.Z)(classes.helpLink, 'takeBack__help-link'),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                            asText: true,
                                                                            data: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.states_explanation_link,
                                                                            defaultText: t('texts:takeBack:states_explanation_link')
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_StatesModal, {
                                                        open: openStatesModal,
                                                        handleClose: function() {
                                                            return setOpenStatesModal(false);
                                                        },
                                                        takeBackData: takeBackData,
                                                        entries: entries
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !(takeBack === null || takeBack === void 0 ? void 0 : takeBack.loading) && showCriterion && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)(classes.referenceImage),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "data-ratio": aspectRatio,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                            classes: classes.imageSize,
                                            imagePaths: takeBack === null || takeBack === void 0 ? void 0 : (ref7 = takeBack.response) === null || ref7 === void 0 ? void 0 : ref7.images[0],
                                            settings: {
                                                width: mediumImgWidth,
                                                ar: aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.substring(3),
                                                defaultImage: main === null || main === void 0 ? void 0 : (ref8 = main.data) === null || ref8 === void 0 ? void 0 : ref8.default_image
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'h3',
                                        className: (0,clsx_m/* default */.Z)(classes.referenceImageTitle, 'takeBack__confirmation_image__title'),
                                        children: takeBack === null || takeBack === void 0 ? void 0 : (ref9 = takeBack.response) === null || ref9 === void 0 ? void 0 : ref9.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classes.center,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            size: 'small',
                                            variant: "contained",
                                            color: "primary",
                                            onClick: onSubmitFirstStep,
                                            className: classes.buttonNextPart,
                                            disabled: disabledButtonsecondPart,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.reference_check_button,
                                                defaultText: t('texts:takeBack:reference_check_button')
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.show_confirmation) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationDialog, {
                open: !!confirmationDialogState,
                onConfirm: handleCloseConfirmationDialog,
                onClose: handleCloseConfirmationDialog,
                title: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.second_confirmation_title,
                body: confirmationDialogState && (confirmationModalContent[confirmationDialogState] || null),
                confirmText: takeBackData === null || takeBackData === void 0 ? void 0 : takeBackData.second_confirmation_button_label
            })
        ]
    }));
};
/* harmony default export */ var TakeBack_TakeBackFirstStepSecondPart = (TakeBackFirstStepSecondPart);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroup.js + 1 modules
var RadioGroup = __webpack_require__(37661);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Radio/Radio.js + 4 modules
var Radio = __webpack_require__(32340);
;// CONCATENATED MODULE: ./components/TakeBack/TakeBackFirstStepFirstPart.tsx









var TakeBackFirstStepFirstPart = function(param) {
    var data = param.data, t = param.t, handleResponseFirstPart = param.handleResponseFirstPart, error = param.error, disabledButtonFirstPart = param.disabledButtonFirstPart, handleShowSecondPart = param.handleShowSecondPart, takeBackProductsInformations = param.takeBackProductsInformations, currentProductIndex = param.currentProductIndex;
    var classes = TakeBack_style();
    var ref = (0,react.useState)(false), showConfirmationDialog = ref[0], setShowConfirmationDialog = ref[1];
    var handleShowConfirmationDialog = function(shown) {
        return function() {
            setShowConfirmationDialog(shown);
        };
    };
    var handleConfirmation = function() {
        if (data === null || data === void 0 ? void 0 : data.show_confirmation) {
            setShowConfirmationDialog(true);
        } else {
            handleShowSecondPart();
        }
    };
    var submitConfirmation = function() {
        setShowConfirmationDialog(false);
        handleShowSecondPart();
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h3",
                        component: "h2",
                        className: (0,clsx_m/* default */.Z)(classes.preliminaryQuestionTitle, 'takeBack__preliminaryQuestion__title'),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: data === null || data === void 0 ? void 0 : data.question_title,
                            defaultText: t('texts:takeBack:question_title')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: data === null || data === void 0 ? void 0 : data.questions.map(function(question, index) {
                            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                container: true,
                                spacing: 0,
                                alignItems: "center",
                                wrap: "nowrap",
                                className: (0,clsx_m/* default */.Z)(classes.preliminaryQuestion, classes.marginBottom, 'takeBack__preliminaryQuestion'),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 'auto',
                                        className: classes.preliminaryQuestionCol,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "body1",
                                            component: "div",
                                            className: (0,clsx_m/* default */.Z)(classes.preliminaryQuestionText, 'takeBack__preliminaryQuestion__text'),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    data: question.question,
                                                    defaultText: t('texts:takeBack:condition_question')
                                                }),
                                                question.is_required && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (0,clsx_m/* default */.Z)(classes.preliminaryQuestionRequired, 'takeBack__preliminaryQuestion__required'),
                                                    children: "*"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 'auto',
                                        className: (0,clsx_m/* default */.Z)(classes.preliminaryQuestionAnswer, 'radio', 'takeBack__preliminaryQuestion__answer'),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                            required: question.is_required,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
                                                row: true,
                                                onChange: function(event) {
                                                    return handleResponseFirstPart(event, index);
                                                },
                                                defaultValue: takeBackProductsInformations[currentProductIndex].answers[index].answer,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                        name: (0,CMSText/* prismicText */.yz)(question === null || question === void 0 ? void 0 : question.question),
                                                        value: "true",
                                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                            color: "primary"
                                                        }),
                                                        label: t('texts:takeBack:positive_response_to_preliminary_questions'),
                                                        labelPlacement: 'end'
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                        name: (0,CMSText/* prismicText */.yz)(question === null || question === void 0 ? void 0 : question.question),
                                                        value: "false",
                                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                            color: "primary"
                                                        }),
                                                        label: t('texts:takeBack:negative_response_to_preliminary_questions'),
                                                        labelPlacement: 'end'
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }, index));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "p",
                        className: (0,clsx_m/* default */.Z)(classes.firstStepTextRequired, 'takeBack__required-field'),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: data === null || data === void 0 ? void 0 : data.required_field,
                            defaultText: t('texts:takeBack:required_field')
                        })
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                        in: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body1",
                            component: "div",
                            className: (0,clsx_m/* default */.Z)('takeBack__error', classes.preliminaryQuestionsError, classes.error, classes.marginBottom),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {
                                    color: "inherit"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    data: data === null || data === void 0 ? void 0 : data.error_message,
                                    defaultText: t('texts:takeBack:error_message')
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)(classes.center, 'takeBack__firstStep__submit'),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            size: "small",
                            variant: "contained",
                            color: "primary",
                            onClick: handleConfirmation,
                            disabled: disabledButtonFirstPart,
                            className: classes.buttonNextPart,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: data === null || data === void 0 ? void 0 : data.next_step_button,
                                defaultText: t('texts:takeBack:next_step_button')
                            })
                        })
                    })
                ]
            }),
            (data === null || data === void 0 ? void 0 : data.show_confirmation) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationDialog, {
                open: showConfirmationDialog,
                onConfirm: submitConfirmation,
                onClose: handleShowConfirmationDialog(false),
                title: data === null || data === void 0 ? void 0 : data.first_confirmation_title,
                body: data === null || data === void 0 ? void 0 : data.first_confirmation_body,
                confirmText: data === null || data === void 0 ? void 0 : data.first_confirmation_button_label
            })
        ]
    }));
};
/* harmony default export */ var TakeBack_TakeBackFirstStepFirstPart = (TakeBackFirstStepFirstPart);

// EXTERNAL MODULE: ./redux/actions/takeBack.ts + 1 modules
var actions_takeBack = __webpack_require__(42738);
;// CONCATENATED MODULE: ./components/TakeBack/TakeBackFirstStep.tsx
/* provided dependency */ var process = __webpack_require__(34155);









function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var mapStateToProps = function(state) {
    return {
        takeBack: state.takeBack
    };
};
var mapDispatchToProps = {
    getTakeBackRef: actions_takeBack/* getTakeBackRef */.hY,
    getTakeBackProduct: actions_takeBack/* getTakeBackProduct */.vq
};
var TakeBackFirstStep = function(param) {
    var prismicTakeBack = param.prismicTakeBack, t = param.t, handleNextStep = param.handleNextStep, getTakeBackRef1 = param.getTakeBackRef, getTakeBackProduct1 = param.getTakeBackProduct, setPriceValue = param.setPriceValue, takeBack = param.takeBack, handleTakeBackProductsInformations = param.handleTakeBackProductsInformations, show = param.show, setShow = param.setShow, takeBackProductsInformations = param.takeBackProductsInformations, currentProductIndex = param.currentProductIndex, showCriterion = param.showCriterion, setShowCriterion = param.setShowCriterion, productStateObject = param.productStateObject, main = param.main, lang = param.lang;
    var ref16, ref1, ref2, ref3, ref4, ref5, ref6;
    var classes = TakeBack_style();
    var ref7 = (0,react.useState)(true), disabledButtonFirstPart = ref7[0], setDisabledButtonFirstPart = ref7[1];
    var ref8 = (0,react.useState)(false), error = ref8[0], setError = ref8[1];
    var ref9 = (0,react.useState)(false), errorReference = ref9[0], setErrorReference = ref9[1];
    // const [isLoadingProduct, setIsLoadingProduct] = useState(false)
    var ref10 = (0,react.useState)(), searchProduct = ref10[0], setSearchProduct = ref10[1];
    var ref11 = (0,react.useState)(((ref16 = takeBackProductsInformations[currentProductIndex]) === null || ref16 === void 0 ? void 0 : ref16.labelReference) ? takeBackProductsInformations[currentProductIndex].labelReference : ''), referenceNumberValue1 = ref11[0], setReferenceNumberValue = ref11[1];
    var ref12 = (0,react.useState)(((ref1 = takeBackProductsInformations[currentProductIndex]) === null || ref1 === void 0 ? void 0 : ref1.lizeeSKU) ? (ref2 = takeBackProductsInformations[currentProductIndex]) === null || ref2 === void 0 ? void 0 : ref2.lizeeSKU : ''), selectValue = ref12[0], setSelectValue = ref12[1];
    var ref13 = (0,react.useState)(((ref3 = takeBackProductsInformations[currentProductIndex]) === null || ref3 === void 0 ? void 0 : ref3.quality) ? (ref4 = takeBackProductsInformations[currentProductIndex]) === null || ref4 === void 0 ? void 0 : ref4.quality : ''), productState = ref13[0], setProductState = ref13[1];
    var entries = Object.entries(productStateObject);
    var ref14 = (0,react.useState)(true), disabledButtonsecondPart = ref14[0], setDisabledButtonsecondPart = ref14[1];
    var handleResponseFirstPart = function(event, index) {
        var tempArray = takeBackProductsInformations[currentProductIndex];
        tempArray.answers[index].answer = event.target.value;
        handleTakeBackProductsInformations(true, false, tempArray.answers);
    };
    (0,react.useEffect)(function() {
        var ref, ref15;
        var responses = [];
        takeBackProductsInformations.length > 0 && ((ref = takeBackProductsInformations[currentProductIndex]) === null || ref === void 0 ? void 0 : (ref15 = ref.answers) === null || ref15 === void 0 ? void 0 : ref15.map(function(availableAnswer) {
            if (availableAnswer.required) {
                responses.push(availableAnswer.answer);
            }
            if (Object.values(responses).includes('false')) {
                setError(true);
                setDisabledButtonFirstPart(true);
            } else if (Object.values(responses).includes('')) {
                setError(false);
                setDisabledButtonFirstPart(true);
            } else {
                setError(false);
                setDisabledButtonFirstPart(false);
            }
        }));
    }, [
        takeBackProductsInformations
    ]);
    var handleShowSecondPart = function() {
        setShow(false);
    };
    (0,react.useEffect)(function() {
        if ((referenceNumberValue1 === undefined || referenceNumberValue1 === '') && searchProduct === undefined || selectValue === '' || productState === '') {
            setDisabledButtonsecondPart(true);
        } else {
            setDisabledButtonsecondPart(false);
        }
    }, [
        referenceNumberValue1,
        productState,
        selectValue
    ]);
    var handleReferenceNumberValue = function(value) {
        setReferenceNumberValue(value);
        if (errorReference) setErrorReference(false);
    };
    var handleCheckReference = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(referenceNumberValue) {
            var refResponse;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getTakeBackRef1(referenceNumberValue);
                    case 2:
                        refResponse = _ctx.sent;
                        if (refResponse.type === actions_takeBack/* ACTIONS.GET_TAKE_BACK_REFERENCE_FAILURE */.aO.GET_TAKE_BACK_REFERENCE_FAILURE) {
                            setShowCriterion(false);
                            setErrorReference(true);
                        } else {
                            setErrorReference(false);
                            setShowCriterion(true);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCheckReference(referenceNumberValue) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var ref;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(process.env.SIMPLIFIED_TAKE_BACK && process.env.TAKE_BACK_SELECTED_PRODUCT)) {
                                _ctx.next = 5;
                                break;
                            }
                            if (searchProduct) {
                                _ctx.next = 4;
                                break;
                            }
                            _ctx.next = 4;
                            return handleCheckProduct(Number(process.env.TAKE_BACK_SELECTED_PRODUCT));
                        case 4:
                            if (searchProduct) {
                                ;
                                setSelectValue(searchProduct === null || searchProduct === void 0 ? void 0 : (ref = searchProduct.variants) === null || ref === void 0 ? void 0 : ref[0].sku);
                                setProductState('goodCondition');
                                if (selectValue && productState) {
                                    if (!show) onSubmitFirstStep();
                                }
                            }
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, [
        searchProduct,
        selectValue,
        productState,
        show
    ]);
    var handleCheckProduct = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(productId) {
            var refResponse;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getTakeBackProduct1(productId);
                    case 2:
                        refResponse = _ctx.sent;
                        if (refResponse.type === actions_takeBack/* ACTIONS.GET_TAKE_BACK_ID_FAILURE */.aO.GET_TAKE_BACK_ID_FAILURE) {
                            setErrorReference(true);
                            setShowCriterion(false);
                        } else {
                            setErrorReference(false);
                            setShowCriterion(true);
                            setSearchProduct(refResponse.response);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCheckProduct(productId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleState = function(event) {
        setProductState(event.target.value);
    };
    var handleSelect = function(event) {
        setSelectValue(event.target.value);
    };
    // handle first step answers
    var onSubmitFirstStep = function() {
        var ref, ref17, ref18, ref19, ref20, ref21;
        var currentVariant = takeBack === null || takeBack === void 0 ? void 0 : (ref = takeBack.response) === null || ref === void 0 ? void 0 : (ref17 = ref.variants) === null || ref17 === void 0 ? void 0 : ref17.find(function(variant) {
            return variant.sku === selectValue;
        });
        var currentPrice = currentVariant.channelPricings.WEB.pricingTakeBack[productState];
        setPriceValue(currentPrice);
        var currentSizeNumber = currentVariant.newSize.name;
        handleNextStep();
        var productInfos = {
            lizeeSKU: selectValue,
            labelReference: referenceNumberValue1,
            quantity: 1,
            quality: productState,
            amount: Number(currentPrice),
            productName: takeBack === null || takeBack === void 0 ? void 0 : (ref18 = takeBack.response) === null || ref18 === void 0 ? void 0 : ref18.name,
            size: currentSizeNumber,
            image: {
                path: takeBack === null || takeBack === void 0 ? void 0 : (ref19 = takeBack.response) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.images) === null || ref20 === void 0 ? void 0 : (ref21 = ref20[0]) === null || ref21 === void 0 ? void 0 : ref21.path
            },
            withoutLabelReference: !!searchProduct
        };
        handleTakeBackProductsInformations(false, true, productInfos);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)(classes.firstStepFirstPartContainer, 'takeBack__firstStep__container', showCriterion && 'takeBack__firstStep__container--success'),
        children: show ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: takeBackProductsInformations.length > 0 && takeBackProductsInformations[currentProductIndex] && ((ref5 = takeBackProductsInformations[currentProductIndex]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.answers) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_TakeBackFirstStepFirstPart, {
                data: prismicTakeBack === null || prismicTakeBack === void 0 ? void 0 : prismicTakeBack.data,
                t: t,
                handleResponseFirstPart: handleResponseFirstPart,
                error: error,
                handleShowSecondPart: handleShowSecondPart,
                disabledButtonFirstPart: disabledButtonFirstPart,
                takeBackProductsInformations: takeBackProductsInformations,
                currentProductIndex: currentProductIndex
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_TakeBackFirstStepSecondPart, {
                prismicTakeBack: prismicTakeBack,
                t: t,
                onSubmitFirstStep: onSubmitFirstStep,
                errorReference: errorReference,
                disabledButtonsecondPart: disabledButtonsecondPart,
                referenceNumberValue: referenceNumberValue1,
                handleReferenceNumberValue: handleReferenceNumberValue,
                selectValue: selectValue,
                handleSelect: handleSelect,
                productState: productState,
                handleState: handleState,
                showCriterion: showCriterion,
                handleCheckReference: handleCheckReference,
                handleCheckProduct: handleCheckProduct,
                takeBack: takeBack,
                entries: entries,
                main: main,
                lang: lang,
                currentProductIndex: currentProductIndex
            })
        })
    }));
};
/* harmony default export */ var TakeBack_TakeBackFirstStep = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(TakeBackFirstStep));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(14903);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CloseOutlined.js
var CloseOutlined = __webpack_require__(31863);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/max/exports/parsePhoneNumberFromString.js + 2 modules
var parsePhoneNumberFromString = __webpack_require__(55400);
// EXTERNAL MODULE: ./components/UserForm/LoginForm.tsx + 1 modules
var LoginForm = __webpack_require__(90189);
// EXTERNAL MODULE: ./redux/actions/user.ts
var user = __webpack_require__(76809);
// EXTERNAL MODULE: ./components/UserForm/RegisterFrom.tsx
var RegisterFrom = __webpack_require__(93748);
// EXTERNAL MODULE: ./components/UserForm/ForgotPasswordForm.tsx
var ForgotPasswordForm = __webpack_require__(38269);
// EXTERNAL MODULE: ./components/UserForm/ConnectedForm.tsx
var ConnectedForm = __webpack_require__(78709);
// EXTERNAL MODULE: ./components/Shop/Price.tsx
var Price = __webpack_require__(31907);
;// CONCATENATED MODULE: ./components/TakeBack/TakeBackPrice.tsx






var TakeBackPrice = function(param) {
    var price = param.price, incentiveValue = param.incentiveValue;
    var classes = TakeBack_style();
    var amount;
    if (incentiveValue !== 0) {
        amount = price + price * incentiveValue / 100;
    } else {
        amount = price;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        component: "div",
        color: "primary",
        className: (0,clsx_m/* default */.Z)('takeBack__price', classes.price),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
            amount: amount,
            showDayOrMonth: false
        })
    }));
};
/* harmony default export */ var TakeBack_TakeBackPrice = (TakeBackPrice);

// EXTERNAL MODULE: ./redux/actions/addressUser.ts + 1 modules
var addressUser = __webpack_require__(78101);
// EXTERNAL MODULE: ./components/Information/AddressForm.tsx + 2 modules
var AddressForm = __webpack_require__(12907);
// EXTERNAL MODULE: ./hooks/useAddress.ts + 1 modules
var useAddress = __webpack_require__(59361);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
;// CONCATENATED MODULE: ./components/TakeBack/TakeBackSecondStep.tsx
/* provided dependency */ var TakeBackSecondStep_process = __webpack_require__(34155);


























function TakeBackSecondStep_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function TakeBackSecondStep_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                TakeBackSecondStep_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                TakeBackSecondStep_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function TakeBackSecondStep_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TakeBackSecondStep_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TakeBackSecondStep_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var TakeBackSecondStep_mapStateToProps = function(state) {
    return {
        user: state.user,
        addressUser: state.addressUser,
        parameters: state.parameters,
        takeBack: state.takeBack
    };
};
var TakeBackSecondStep_mapDispatchToProps = {
    registerUser: user/* registerUser */.a$,
    loginUser: user/* loginUser */.pH,
    getUser: user/* getUser */.PR,
    getAddress: addressUser/* getAddress */.Kn,
    postAddress: addressUser/* postAddress */.L4,
    putAddress: addressUser/* putAddress */.EJ
};
var TakeBackSecondStep = function(param) {
    var takeback = param.takeback, t = param.t, loginUser1 = param.loginUser, getUser1 = param.getUser, parameters = param.parameters, user1 = param.user, registerUser1 = param.registerUser, account = param.account, takeBack = param.takeBack, handleRemoveProduct = param.handleRemoveProduct, addressUser = param.addressUser, getAddress1 = param.getAddress, postAddress1 = param.postAddress, putAddress1 = param.putAddress, handleAddProduct = param.handleAddProduct, takeBackProductsInformations = param.takeBackProductsInformations, handleLogisticsTakeBackData = param.handleLogisticsTakeBackData, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formattedCurrentLocale = param.formattedCurrentLocale, productStateObject = param.productStateObject, showLoginForm = param.showLoginForm, setShowLoginForm = param.setShowLoginForm, main = param.main, funnel = param.funnel, secondStepError = param.secondStepError;
    var ref52, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26;
    var classes = TakeBack_style();
    var router = (0,next_router.useRouter)();
    var currentLocale = (router === null || router === void 0 ? void 0 : router.locale) ? router.locale : 'fr';
    var localPrismic = (0,utils/* setFullLocale */.vQ)(router === null || router === void 0 ? void 0 : router.locale);
    var loading = takeBack === null || takeBack === void 0 ? void 0 : takeBack.loading;
    var ref27 = (0,react.useState)(false), register1 = ref27[0], setIsRegisterForm = ref27[1];
    var ref28 = (0,react.useState)(false), hasRegistered = ref28[0], setHasRegistered = ref28[1];
    var ref29 = (0,react.useState)(false), hasLogin = ref29[0], setHasLogin = ref29[1];
    var ref30 = (0,react.useState)(false), confirmAddress = ref30[0], setConfirmAddress = ref30[1];
    var ref31 = (0,react.useState)(false), loginError = ref31[0], setLoginError = ref31[1];
    var ref32 = (0,react.useState)(false), isConnected = ref32[0], setIsConnected = ref32[1];
    var ref33 = (0,react.useState)(false), errorAccountDisabled = ref33[0], setErrorAccountDisabled = ref33[1];
    var ref34 = (0,react.useState)(true), login = ref34[0], setIsLoginForm = ref34[1];
    var ref35 = (0,react.useState)(false), hasError = ref35[0], setHasError = ref35[1];
    var ref36 = (0,react.useState)(false), errorEmailUsed = ref36[0], setErrorEmailUsed = ref36[1];
    var ref37 = (0,react.useState)(false), errorPhone = ref37[0], setHasErrorPhone = ref37[1];
    var ref38 = (0,react.useState)(false), forgot = ref38[0], setIsForgotForm = ref38[1];
    var ref39 = (0,react.useState)(null), locationValue1 = ref39[0], setLocationValue = ref39[1];
    var ref40 = (0,react.useState)(false), cgu = ref40[0], setCGU = ref40[1];
    var ref41 = (0,react.useState)(false), cguBis = ref41[0], setCGUBis = ref41[1];
    var ref42 = (0,react.useState)(true), disabledButton = ref42[0], setDisableButton = ref42[1];
    var ref43 = (0,react.useState)(0), currentIncentive1 = ref43[0], setCurrentIncentive = ref43[1];
    var ref44 = (0,react.useState)(0), currentTotalAmount1 = ref44[0], setCurrentTotalAmount = ref44[1];
    var ref45 = (0,react.useState)(''), address = ref45[0], setAddress = ref45[1];
    var ref46 = (0,react.useState)(''), details = ref46[0], setDetails = ref46[1];
    var ref47 = (0,react.useState)(''), postalCode = ref47[0], setPostalCode = ref47[1];
    var ref48 = (0,react.useState)(''), town = ref48[0], setTown = ref48[1];
    var ref49 = (0,react.useState)(''), userCountryCode = ref49[0], setUserCountryCode = ref49[1];
    var ref50 = (0,react.useState)((parameters === null || parameters === void 0 ? void 0 : (ref52 = parameters.countries) === null || ref52 === void 0 ? void 0 : ref52[0].code) || currentLocale.toUpperCase()), selectedCountry = ref50[0], setSelectedCountry = ref50[1];
    var smallImgWidth = main === null || main === void 0 ? void 0 : (ref1 = main.data) === null || ref1 === void 0 ? void 0 : ref1.small_image_size;
    var aspectRatio = (0,utils/* thumbnailRatio */.pm)(main === null || main === void 0 ? void 0 : (ref2 = main.data) === null || ref2 === void 0 ? void 0 : ref2.thumbnail_ratio);
    var showAddressVerification = takeback === null || takeback === void 0 ? void 0 : (ref3 = takeback.data) === null || ref3 === void 0 ? void 0 : ref3.take_back_location_verification_enabled;
    var trackPageView = (0,useMatomo/* default */.Z)().trackPageView;
    var takeBackSimplified = TakeBackSecondStep_process.env.SIMPLIFIED_TAKE_BACK;
    (0,react.useEffect)(function() {
        var total = 0;
        takeBackProductsInformations.map(function(product) {
            total = total + product.amount;
        });
        setCurrentTotalAmount(total);
    }, [
        takeBackProductsInformations
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if ((user1 === null || user1 === void 0 ? void 0 : (ref = user1.user) === null || ref === void 0 ? void 0 : ref.id) && !hasLogin) {
            if (showAddressVerification) getAddress1();
            setIsConnected(true);
            setIsLoginForm(false);
            setIsRegisterForm(false);
        } else {
            setIsConnected(false);
        }
    }, [
        user1 === null || user1 === void 0 ? void 0 : user1.user
    ]);
    var ref51 = (0,useAddress/* useAddress */.S)(), inputAddress = ref51.address;
    (0,react.useEffect)(function() {
        var ref, ref53;
        if (isConnected && showLoginForm && (user1 === null || user1 === void 0 ? void 0 : (ref = user1.user) === null || ref === void 0 ? void 0 : (ref53 = ref.address) === null || ref53 === void 0 ? void 0 : ref53.city)) {
            var ref54;
            if (showAddressVerification) {
                var ref55, ref56, ref57, ref58, ref59, ref60, ref61, ref62, ref63, ref64;
                setAddress(user1 === null || user1 === void 0 ? void 0 : (ref55 = user1.user) === null || ref55 === void 0 ? void 0 : (ref56 = ref55.address) === null || ref56 === void 0 ? void 0 : ref56.street);
                setDetails(user1 === null || user1 === void 0 ? void 0 : (ref57 = user1.user) === null || ref57 === void 0 ? void 0 : (ref58 = ref57.address) === null || ref58 === void 0 ? void 0 : ref58.details);
                setPostalCode(user1 === null || user1 === void 0 ? void 0 : (ref59 = user1.user) === null || ref59 === void 0 ? void 0 : (ref60 = ref59.address) === null || ref60 === void 0 ? void 0 : ref60.postcode);
                setTown(user1 === null || user1 === void 0 ? void 0 : (ref61 = user1.user) === null || ref61 === void 0 ? void 0 : (ref62 = ref61.address) === null || ref62 === void 0 ? void 0 : ref62.city);
                setUserCountryCode(user1 === null || user1 === void 0 ? void 0 : (ref63 = user1.user) === null || ref63 === void 0 ? void 0 : (ref64 = ref63.address) === null || ref64 === void 0 ? void 0 : ref64.countryCode);
                if (!hasRegistered) {
                    setConfirmAddress(true);
                }
            } else {
                var ref65, ref66, ref67, ref68, ref69, ref70, ref71, ref72, ref73, ref74, ref75, ref76, ref77, ref78;
                var data = {
                    firstName: user1 === null || user1 === void 0 ? void 0 : (ref65 = user1.user) === null || ref65 === void 0 ? void 0 : ref65.firstName.trim(),
                    lastName: user1 === null || user1 === void 0 ? void 0 : (ref66 = user1.user) === null || ref66 === void 0 ? void 0 : ref66.lastName.trim(),
                    // gender: user?.user?.gender,
                    phoneNumber: user1 === null || user1 === void 0 ? void 0 : (ref67 = user1.user) === null || ref67 === void 0 ? void 0 : (ref68 = ref67.address) === null || ref68 === void 0 ? void 0 : ref68.phoneNumber,
                    street: user1 === null || user1 === void 0 ? void 0 : (ref69 = user1.user) === null || ref69 === void 0 ? void 0 : (ref70 = ref69.address) === null || ref70 === void 0 ? void 0 : ref70.street,
                    postcode: user1 === null || user1 === void 0 ? void 0 : (ref71 = user1.user) === null || ref71 === void 0 ? void 0 : (ref72 = ref71.address) === null || ref72 === void 0 ? void 0 : ref72.postcode,
                    details: user1 === null || user1 === void 0 ? void 0 : (ref73 = user1.user) === null || ref73 === void 0 ? void 0 : (ref74 = ref73.address) === null || ref74 === void 0 ? void 0 : ref74.details,
                    // email: user?.user?.email.trim(),
                    city: user1 === null || user1 === void 0 ? void 0 : (ref75 = user1.user) === null || ref75 === void 0 ? void 0 : (ref76 = ref75.address) === null || ref76 === void 0 ? void 0 : ref76.city.trim(),
                    countryCode: user1 === null || user1 === void 0 ? void 0 : (ref77 = user1.user) === null || ref77 === void 0 ? void 0 : (ref78 = ref77.address) === null || ref78 === void 0 ? void 0 : ref78.countryCode.toUpperCase()
                };
                onConnectedSubmit(data);
            }
            localStorage.setItem('email', user1 === null || user1 === void 0 ? void 0 : (ref54 = user1.user) === null || ref54 === void 0 ? void 0 : ref54.email);
        }
    }, [
        showLoginForm,
        isConnected,
        user1 === null || user1 === void 0 ? void 0 : user1.user
    ]);
    var handleShowLoginForm = function() {
        setShowLoginForm(true);
        window === null || window === void 0 ? void 0 : window.scroll(0, 0);
    };
    var switchForm = function(id) {
        setIsRegisterForm(false);
        setIsConnected(false);
        setLoginError(false);
        setHasError(false);
        setErrorEmailUsed(false);
        setErrorAccountDisabled(false);
        setHasErrorPhone(false);
        setIsForgotForm(false);
        setIsLoginForm(false);
        switch(id){
            case 1:
                setIsRegisterForm(true);
                break;
            case 3:
                setIsConnected(true);
                break;
            case 4:
                setIsLoginForm(true);
                break;
            case 5:
                setIsForgotForm(true);
                break;
            default:
                break;
        }
    };
    var submitLogin = function() {
        var _ref = TakeBackSecondStep_asyncToGenerator(runtime_default().mark(function _callee(data) {
            var log, ref, ref79, ref80;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
                        _ctx.next = 3;
                        return loginUser1(data);
                    case 3:
                        log = _ctx.sent;
                        setLoginError(false);
                        if (log.type === 'LOGIN_USER_FAILURE') {
                            ;
                            if ((log === null || log === void 0 ? void 0 : (ref = log.err) === null || ref === void 0 ? void 0 : (ref79 = ref.response) === null || ref79 === void 0 ? void 0 : (ref80 = ref79.data) === null || ref80 === void 0 ? void 0 : ref80.message) === 'Account is disabled.') {
                                setErrorAccountDisabled(true);
                            } else {
                                setLoginError(true);
                                setIsConnected(false);
                                setIsLoginForm(true);
                            }
                        } else {
                            setLoginError(false);
                            setIsRegisterForm(false);
                            setIsConnected(true);
                            setIsLoginForm(false);
                            if (log.token.token) {
                                localStorage.setItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN, log.token.token);
                                getUser1();
                            }
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitLogin(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var submitRegistration = function() {
        var _ref = TakeBackSecondStep_asyncToGenerator(runtime_default().mark(function _callee(data) {
            var register, ref, dataLogin, ref81, ref82, ref83, ref84, ref85;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
                        setHasError(false);
                        setErrorEmailUsed(false);
                        setHasErrorPhone(false);
                        if (![
                            'MOBILE',
                            'FIXED_LINE_OR_MOBILE'
                        ].includes((0,parsePhoneNumberFromString/* parsePhoneNumberFromString */._)(data === null || data === void 0 ? void 0 : data.phoneNumber).getType())) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 7;
                        return registerUser1(data);
                    case 7:
                        register = _ctx.sent;
                        if (register.type === 'REGISTER_USER_SUCCESS') {
                            ;
                            if (!(parameters === null || parameters === void 0 ? void 0 : (ref = parameters.items) === null || ref === void 0 ? void 0 : ref.isAccountVerificationRequired)) {
                                dataLogin = {
                                    email: data.email,
                                    password: data.plainPassword
                                };
                                submitLogin(dataLogin);
                                setIsRegisterForm(false);
                                setIsConnected(true);
                                setHasRegistered(true);
                                setHasLogin(false);
                            } else {
                                setIsRegisterForm(false);
                                setIsLoginForm(true);
                                setHasRegistered(true);
                            }
                        } else {
                            ;
                            if ((register === null || register === void 0 ? void 0 : (ref81 = register.err) === null || ref81 === void 0 ? void 0 : (ref82 = ref81.response) === null || ref82 === void 0 ? void 0 : (ref83 = ref82.data) === null || ref83 === void 0 ? void 0 : (ref84 = ref83.errors) === null || ref84 === void 0 ? void 0 : (ref85 = ref84.email) === null || ref85 === void 0 ? void 0 : ref85[0]) === 'This email is already used.') {
                                setErrorEmailUsed(true);
                            } else {
                                setHasError(true);
                            }
                        }
                        _ctx.next = 12;
                        break;
                    case 11:
                        {
                            setHasErrorPhone(true);
                        }
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitRegistration(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var calculateTotalAmount = function(currentTotalAmount, currentIncentive) {
        return parseFloat((currentTotalAmount + currentTotalAmount * currentIncentive / 100).toFixed(0));
    };
    var buildUserInfosRMS = function(user, locationValue) {
        return {
            firstname: user.user.firstName,
            lastname: user.user.lastName,
            phone: user.user.phoneNumber,
            gender: user.user.gender,
            company: "".concat(user.user.firstName, " ").concat(user.user.lastName),
            email: user.user.email,
            voucherLocation: locationValue
        };
    };
    var onConnectedSubmit = function(data) {
        var ref, ref86, ref87;
        setHasLogin(false);
        var totalAmount = calculateTotalAmount(currentTotalAmount1, currentIncentive1);
        var userInfoOMS = {
            firstName: user1 === null || user1 === void 0 ? void 0 : (ref = user1.user) === null || ref === void 0 ? void 0 : ref.firstName,
            lastName: user1 === null || user1 === void 0 ? void 0 : (ref86 = user1.user) === null || ref86 === void 0 ? void 0 : ref86.lastName,
            phoneNumber: user1 === null || user1 === void 0 ? void 0 : (ref87 = user1.user) === null || ref87 === void 0 ? void 0 : ref87.phoneNumber
        };
        var userInfosRMS = buildUserInfosRMS(user1, locationValue1);
        if (data) {
            var ref88;
            var modifiedData = {
                address: data.street,
                zipcode: data.postcode,
                country: (takeback === null || takeback === void 0 ? void 0 : (ref88 = takeback.data) === null || ref88 === void 0 ? void 0 : ref88.enable_take_back_country) && selectedCountry ? selectedCountry : data.countryCode,
                city: data.city,
                locale: (0,utils/* transformLocale */.fK)(localPrismic)
            };
            var sendInfos = TakeBackSecondStep_objectSpread({}, modifiedData, userInfosRMS, {
                totalAmount: totalAmount
            });
            postAddress1(TakeBackSecondStep_objectSpread({}, userInfoOMS, data));
            //NEXT STEP HERE ONLY AFTER validate address
            handleLogisticsTakeBackData(sendInfos, currentIncentive1);
        }
    };
    var onConfirmAddress = function(data) {
        setHasLogin(false);
        var totalAmount = calculateTotalAmount(currentTotalAmount1, currentIncentive1);
        var userInfosRMS = buildUserInfosRMS(user1, locationValue1);
        if (data) {
            var ref;
            var modifiedData = {
                address: inputAddress.payload.street,
                zipcode: inputAddress.payload.postcode,
                city: inputAddress.payload.city,
                country: inputAddress.payload.countryCode,
                locale: (0,utils/* transformLocale */.fK)(localPrismic)
            };
            var sendInfos = TakeBackSecondStep_objectSpread({}, modifiedData, userInfosRMS, {
                totalAmount: totalAmount
            });
            if ((addressUser === null || addressUser === void 0 ? void 0 : (ref = addressUser.items) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                putAddress1(TakeBackSecondStep_objectSpread({
                    firstName: user1.user.firstName,
                    lastName: user1.user.lastName,
                    phoneNumber: user1.user.phoneNumber
                }, inputAddress.payload), addressUser.items[0].id);
            } else {
                var ref89, ref90, ref91;
                var userInfoOMS = {
                    firstName: user1 === null || user1 === void 0 ? void 0 : (ref89 = user1.user) === null || ref89 === void 0 ? void 0 : ref89.firstName,
                    lastName: user1 === null || user1 === void 0 ? void 0 : (ref90 = user1.user) === null || ref90 === void 0 ? void 0 : ref90.lastName,
                    phoneNumber: user1 === null || user1 === void 0 ? void 0 : (ref91 = user1.user) === null || ref91 === void 0 ? void 0 : ref91.phoneNumber
                };
                postAddress1(TakeBackSecondStep_objectSpread({}, userInfoOMS, data));
            }
            //NEXT STEP HERE ONLY AFTER validate address
            handleLogisticsTakeBackData(sendInfos, currentIncentive1);
        }
    };
    var handleLocation = function(event) {
        var ref;
        var currentLocation = takeback === null || takeback === void 0 ? void 0 : (ref = takeback.data) === null || ref === void 0 ? void 0 : ref.take_back_locations.find(function(location) {
            return (0,CMSText/* prismicText */.yz)(location === null || location === void 0 ? void 0 : location.location_api_key) === event.target.value;
        });
        var currentIncentiveLocation = currentLocation.incentive;
        setCurrentIncentive(currentIncentiveLocation);
        setLocationValue(event.target.value);
    };
    (0,react.useEffect)(function() {
        var ref;
        if (locationValue1 === null) {
            setDisableButton(true);
        } else if (!cgu) {
            setDisableButton(true);
        } else if ((0,CMSText/* isPrismicText */.LT)(takeback === null || takeback === void 0 ? void 0 : (ref = takeback.data) === null || ref === void 0 ? void 0 : ref.text_confirmation) && !cguBis) {
            setDisableButton(true);
        } else {
            setDisableButton(false);
        }
    }, [
        locationValue1,
        cgu,
        cguBis
    ]);
    var changeCGU = function() {
        setCGU(!cgu);
    };
    var changeCGUBis = function() {
        setCGUBis(!cguBis);
    };
    (0,react.useEffect)(function() {
        trackPageView({
            documentTitle: 'Take Back Program - Second Step'
        });
        window === null || window === void 0 ? void 0 : window.scrollTo(0, 0);
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)(classes.takeBackSecondStepContainer, 'takeBack__secondStep__container'),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)(classes.takeBackSecondStep, 'takeBack__secondStep'),
            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                in: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    textAlign: 'center',
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            data: takeback === null || takeback === void 0 ? void 0 : (ref4 = takeback.data) === null || ref4 === void 0 ? void 0 : ref4.waiting_price_text,
                            defaultText: t('texts:takeBack:waiting_price_text')
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: !showLoginForm ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            component: "div",
                            className: (0,clsx_m/* default */.Z)(classes.takeBackOffer, 'takeBack-offer__title'),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                data: takeback === null || takeback === void 0 ? void 0 : (ref5 = takeback.data) === null || ref5 === void 0 ? void 0 : ref5.offer_announcement_text,
                                defaultText: t('texts:takeBack:offer_announcement_text')
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: takeBackProductsInformations.map(function(product, index) {
                                var ref, ref92, ref93, ref94;
                                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.productItem,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.productImage,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                "data-ratio": aspectRatio,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                                    classes: classes.imageSize,
                                                    imagePaths: product.image.path ? product.image : (ref = takeBack.response) === null || ref === void 0 ? void 0 : ref.images[0],
                                                    settings: {
                                                        width: smallImgWidth,
                                                        ar: aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.substring(3),
                                                        defaultImage: main === null || main === void 0 ? void 0 : (ref92 = main.data) === null || ref92 === void 0 ? void 0 : ref92.default_image
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.productDetails,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (0,clsx_m/* default */.Z)(classes.productDescription, 'product__description'),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "h3",
                                                            component: 'p',
                                                            className: (0,clsx_m/* default */.Z)(classes.productName, 'product__name'),
                                                            children: product.productName
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            variant: "body2",
                                                            className: (0,clsx_m/* default */.Z)(classes.productMeta, 'product__meta'),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: takeback === null || takeback === void 0 ? void 0 : (ref93 = takeback.data) === null || ref93 === void 0 ? void 0 : ref93.reference,
                                                                    defaultText: t('texts:takeBack:reference')
                                                                }),
                                                                ' ',
                                                                product.labelReference
                                                            ]
                                                        }),
                                                        !takeBackSimplified && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "body2",
                                                            className: (0,clsx_m/* default */.Z)(classes.productMeta, 'product__meta'),
                                                            children: product.size
                                                        }),
                                                        !takeBackSimplified && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            variant: "body2",
                                                            component: 'div',
                                                            className: (0,clsx_m/* default */.Z)(classes.productStatePrice, 'product__state-price'),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (0,clsx_m/* default */.Z)(classes.productMeta, 'product__meta', 'product__state'),
                                                                    children: (ref94 = productStateObject[product.quality]) === null || ref94 === void 0 ? void 0 : ref94.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_TakeBackPrice, {
                                                                    price: product.amount,
                                                                    incentiveValue: currentIncentive1
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                !takeBackSimplified && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    disableRipple: true,
                                                    size: "small",
                                                    onClick: function() {
                                                        return handleRemoveProduct(index);
                                                    },
                                                    className: (0,clsx_m/* default */.Z)(classes.productDelete, 'product__delete'),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined/* default */.Z, {})
                                                })
                                            ]
                                        })
                                    ]
                                }, index));
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.totalContainer,
                            children: [
                                !takeBackSimplified && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        size: "small",
                                        variant: "contained",
                                        color: "secondary",
                                        className: (0,clsx_m/* default */.Z)(classes.SecondStepButton, 'takeBack__add-product-btn'),
                                        onClick: function() {
                                            return handleAddProduct();
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: takeback === null || takeback === void 0 ? void 0 : (ref6 = takeback.data) === null || ref6 === void 0 ? void 0 : ref6.add_product_button,
                                            defaultText: t('texts:takeBack:add_product')
                                        })
                                    })
                                }),
                                !takeBackSimplified && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)(classes.totalPrice, 'products__total__amount'),
                                    id: "takeBack_total_amount",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: takeback === null || takeback === void 0 ? void 0 : (ref7 = takeback.data) === null || ref7 === void 0 ? void 0 : ref7.total_price,
                                            defaultText: t('texts:takeBack:total')
                                        }),
                                        "\xa0:\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_TakeBackPrice, {
                                            price: currentTotalAmount1,
                                            incentiveValue: currentIncentive1
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.locationContainer,
                            children: [
                                (takeback === null || takeback === void 0 ? void 0 : (ref8 = takeback.data) === null || ref8 === void 0 ? void 0 : ref8.enable_take_back_country) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: (0,clsx_m/* default */.Z)(classes.locationTitle, 'takeBack__location__title'),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                data: takeback === null || takeback === void 0 ? void 0 : (ref9 = takeback.data) === null || ref9 === void 0 ? void 0 : ref9.take_back_country_title,
                                                defaultText: t('texts:takeBack:take_back_location_title')
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                                    className: (0,clsx_m/* default */.Z)(classes.formControl),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                                        value: selectedCountry,
                                                        onChange: function(event) {
                                                            return setSelectedCountry(event.target.value);
                                                        },
                                                        className: (0,clsx_m/* default */.Z)(classes.selector, 'takeBack__select'),
                                                        children: (parameters === null || parameters === void 0 ? void 0 : (ref10 = parameters.countries) === null || ref10 === void 0 ? void 0 : ref10.length) > 0 && (parameters === null || parameters === void 0 ? void 0 : parameters.countries.map(function(option, index) {
                                                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: option === null || option === void 0 ? void 0 : option.code,
                                                                children: option === null || option === void 0 ? void 0 : option.name
                                                            }, index));
                                                        }))
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    className: (0,clsx_m/* default */.Z)(classes.locationTitle, 'takeBack__location__title')
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.locationTitleContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: (0,clsx_m/* default */.Z)(classes.locationTitle, 'takeBack__location__title'),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                data: takeback === null || takeback === void 0 ? void 0 : (ref11 = takeback.data) === null || ref11 === void 0 ? void 0 : ref11.take_back_location_title,
                                                defaultText: t('texts:takeBack:take_back_location_title')
                                            })
                                        }),
                                        (0,CMSText/* prismicText */.yz)(takeback === null || takeback === void 0 ? void 0 : (ref12 = takeback.data) === null || ref12 === void 0 ? void 0 : ref12.take_back_location_explanation).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            component: "div",
                                            className: (0,clsx_m/* default */.Z)(classes.locationDesc, 'takeBack__location__explanation'),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                data: takeback === null || takeback === void 0 ? void 0 : (ref13 = takeback.data) === null || ref13 === void 0 ? void 0 : ref13.take_back_location_explanation,
                                                defaultText: t('texts:takeBack:take_back_location_desc')
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                    component: "fieldset",
                                    className: (0,clsx_m/* default */.Z)('takeBack__location__choice'),
                                    children: takeback === null || takeback === void 0 ? void 0 : (ref14 = takeback.data) === null || ref14 === void 0 ? void 0 : ref14.take_back_locations.map(function(location, index) {
                                        var ref;
                                        //hide location if only available for specific countries
                                        if (location.only_available_for.length && (takeback === null || takeback === void 0 ? void 0 : (ref = takeback.data) === null || ref === void 0 ? void 0 : ref.enable_take_back_country)) {
                                            var countriesAvailable = location.only_available_for[0].text.split(',').map(function(country) {
                                                return country.trim();
                                            });
                                            if (!countriesAvailable.includes(selectedCountry)) {
                                                return;
                                            }
                                        }
                                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
                                            row: true,
                                            value: locationValue1,
                                            onChange: handleLocation,
                                            className: (0,clsx_m/* default */.Z)(classes.formLabelRow, 'radio', 'takeBack__formLabelRow', 'takeBack__formLabelRow--location'),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                value: (0,CMSText/* prismicText */.yz)(location === null || location === void 0 ? void 0 : location.location_api_key),
                                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                    color: "primary"
                                                }),
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "caption",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        data: location === null || location === void 0 ? void 0 : location.take_back_location
                                                    })
                                                }),
                                                labelPlacement: "end"
                                            })
                                        }, index));
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)(classes.formLabelRow, 'checkbox', 'takeBack__formLabelRow', 'takeback__formLabelRow--cgu'),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    checked: cgu,
                                    onChange: changeCGU,
                                    name: "cgu_agree",
                                    "data-testid": 'cgu_agree'
                                }),
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: 'body2',
                                    component: 'div',
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        data: takeback === null || takeback === void 0 ? void 0 : (ref15 = takeback.data) === null || ref15 === void 0 ? void 0 : ref15.text_cgu
                                    })
                                })
                            })
                        }),
                        (0,CMSText/* isPrismicText */.LT)(takeback === null || takeback === void 0 ? void 0 : (ref16 = takeback.data) === null || ref16 === void 0 ? void 0 : ref16.text_confirmation) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)(classes.formLabelRow, 'checkbox', 'takeBack__formLabelRow', 'takeback__formLabelRow--cgu'),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    checked: cguBis,
                                    onChange: changeCGUBis,
                                    name: "cgu_agree",
                                    "data-testid": 'cgu_agree_bis'
                                }),
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: 'body2',
                                    component: 'div',
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        data: takeback === null || takeback === void 0 ? void 0 : (ref17 = takeback.data) === null || ref17 === void 0 ? void 0 : ref17.text_confirmation
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)(classes.center, classes.takeBackSecondStepSubmit, 'takeBack__secondStep__submit'),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                size: "small",
                                variant: "contained",
                                color: "secondary",
                                className: classes.SecondStepButton,
                                disabled: disabledButton,
                                onClick: function() {
                                    return handleShowLoginForm();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: takeback === null || takeback === void 0 ? void 0 : (ref18 = takeback.data) === null || ref18 === void 0 ? void 0 : ref18.accept_offer_button,
                                    defaultText: t('texts:takeBack:accept_offer_button')
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        login && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginForm/* default */.Z, {
                            hasRegistered: hasRegistered,
                            loginError: loginError,
                            text: account === null || account === void 0 ? void 0 : account.data,
                            takeBackTitle: takeback === null || takeback === void 0 ? void 0 : (ref19 = takeback.data) === null || ref19 === void 0 ? void 0 : ref19.subtitle,
                            isTakeBack: true,
                            t: t,
                            switchForm: switchForm,
                            isFunnel: false,
                            submitLogin: submitLogin,
                            errorAccountDisabled: errorAccountDisabled
                        }),
                        register1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterFrom/* default */.Z, {
                            submitRegistration: submitRegistration,
                            switchForm: switchForm,
                            isLoading: user1.loading,
                            errorPhone: errorPhone,
                            t: t,
                            errorEmailUsed: errorEmailUsed,
                            hasError: hasError,
                            text: account === null || account === void 0 ? void 0 : account.data,
                            isTakeBack: true,
                            takeBackTitle: takeback === null || takeback === void 0 ? void 0 : (ref20 = takeback.data) === null || ref20 === void 0 ? void 0 : ref20.register_text,
                            isFunnel: false
                        }),
                        showAddressVerification && confirmAddress && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    container: true,
                                    spacing: 1,
                                    className: classes.marginBottom,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: 'h4',
                                            align: "center",
                                            children: [
                                                user1 === null || user1 === void 0 ? void 0 : (ref21 = user1.user) === null || ref21 === void 0 ? void 0 : ref21.firstName,
                                                ', ',
                                                (0,CMSText/* prismicText */.yz)(takeback === null || takeback === void 0 ? void 0 : (ref22 = takeback.data) === null || ref22 === void 0 ? void 0 : ref22.text_location_verification_title, t('texts:takeBack:address_check_required'))
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    sm: 12,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressForm/* default */.Z, {
                                        account: true,
                                        prefill: true,
                                        defaultAddress: {
                                            street: address,
                                            details: details,
                                            postcode: postalCode,
                                            city: town,
                                            countryCode: userCountryCode
                                        },
                                        hideAdditionalAddress: funnel === null || funnel === void 0 ? void 0 : (ref23 = funnel.data) === null || ref23 === void 0 ? void 0 : ref23.hide_additional_address
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.validAddress,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        size: "small",
                                        variant: "contained",
                                        color: "secondary",
                                        className: classes.SecondStepButton,
                                        onClick: function() {
                                            return onConfirmAddress({
                                                street: address,
                                                postcode: postalCode,
                                                city: town,
                                                countryCode: userCountryCode
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: takeback === null || takeback === void 0 ? void 0 : (ref24 = takeback.data) === null || ref24 === void 0 ? void 0 : ref24.text_confirm_location_button,
                                            defaultText: t('texts:takeBack:confirm_address_button')
                                        })
                                    })
                                })
                            ]
                        }),
                        isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: !hasLogin ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectedForm/* default */.Z, {
                                onSubmit: hasRegistered ? onConnectedSubmit : (addressUser === null || addressUser === void 0 ? void 0 : (ref25 = addressUser.items) === null || ref25 === void 0 ? void 0 : ref25.length) === 0 || (addressUser === null || addressUser === void 0 ? void 0 : addressUser.items) === undefined ? onConnectedSubmit : function() {
                                    return setConfirmAddress(true);
                                },
                                text: account === null || account === void 0 ? void 0 : account.data,
                                t: t,
                                switchForm: switchForm,
                                userFirstName: user1 === null || user1 === void 0 ? void 0 : (ref26 = user1.user) === null || ref26 === void 0 ? void 0 : ref26.firstName,
                                hasAddress: user1 === null || user1 === void 0 ? void 0 : user1.user,
                                funnel: funnel,
                                isTakeBack: true
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                            })
                        }),
                        forgot && /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPasswordForm/* default */.Z, {
                            isFunnel: false,
                            text: account === null || account === void 0 ? void 0 : account.data,
                            t: t,
                            switchForm: switchForm
                        }),
                        secondStepError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "error",
                            align: "center",
                            children: t('texts:takeBack:step_2_error')
                        })
                    ]
                })
            })
        })
    }));
};
/* harmony default export */ var TakeBack_TakeBackSecondStep = ((0,es/* connect */.$j)(TakeBackSecondStep_mapStateToProps, TakeBackSecondStep_mapDispatchToProps)(TakeBackSecondStep));

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CheckCircle.js
var CheckCircle = __webpack_require__(81395);
// EXTERNAL MODULE: ./components/Link/Link.tsx
var Link = __webpack_require__(31520);
;// CONCATENATED MODULE: ./components/TakeBack/TakeBackThirdStep.tsx












var TakeBackThirdStep_mapStateToProps = function(state) {
    return {
        takeBack: state.takeBack
    };
};
var TakeBackThirdStep_mapDispatchToProps = {};
var TakeBackThirdStep = function(param) {
    var takeback = param.takeback, t = param.t, takeBack = param.takeBack, showVoucherPrintingButton = param.showVoucherPrintingButton;
    var ref10, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var classes = TakeBack_style();
    var theme = (0,useTheme/* default */.Z)();
    var pageBody = (takeback === null || takeback === void 0 ? void 0 : (ref10 = takeback.data) === null || ref10 === void 0 ? void 0 : ref10.body) ? takeback === null || takeback === void 0 ? void 0 : (ref1 = takeback.data) === null || ref1 === void 0 ? void 0 : ref1.body : [];
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));
    var orderNumber = takeBack === null || takeBack === void 0 ? void 0 : (ref2 = takeBack.response) === null || ref2 === void 0 ? void 0 : ref2.id;
    var trackPageView = (0,useMatomo/* default */.Z)().trackPageView;
    (0,react.useEffect)(function() {
        trackPageView({
            documentTitle: 'Take Back Program - Third Step'
        });
        window === null || window === void 0 ? void 0 : window.scrollTo(0, 0);
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(classes.takeBackThirdStep, 'takeBack__thirdStep'),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.confirmationIcon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h3",
                component: 'div',
                className: 'takeBack__thirdStep_confirmation_title',
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    asText: true,
                    data: takeback === null || takeback === void 0 ? void 0 : (ref3 = takeback.data) === null || ref3 === void 0 ? void 0 : ref3.confirmation_title,
                    defaultText: t('texts:takeBack:confirmation_title')
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: 'body2',
                component: 'div',
                className: (0,clsx_m/* default */.Z)('takeBack__thirdStep_confirmation_desc', classes.confirmationText),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: takeback === null || takeback === void 0 ? void 0 : (ref4 = takeback.data) === null || ref4 === void 0 ? void 0 : ref4.your_order_number,
                            defaultText: t('texts:takeBack:your_order_number')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "\xa0",
                            orderNumber,
                            "\xa0"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            data: takeback === null || takeback === void 0 ? void 0 : (ref5 = takeback.data) === null || ref5 === void 0 ? void 0 : ref5.confirmation_text,
                            defaultText: t('texts:takeBack:confirmation_text')
                        })
                    })
                ]
            }),
            pageBody.length !== 0 && pageBody.map(function(item, index1) {
                var ref12;
                var gridItemWidth = (0,utils/* columnLayout */.Zd)(item.items.length);
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    id: "section-".concat(item.slice_type, "-").concat(index1),
                    className: (0,clsx_m/* default */.Z)(classes.section, 'takeBack__thirdStep__section'),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            container: true,
                            spacing: isMobile ? 1 : 3,
                            justify: "center",
                            wrap: isMobile ? 'wrap' : 'nowrap',
                            children: (ref12 = item.items) === null || ref12 === void 0 ? void 0 : ref12.map(function(el, index) {
                                var ref, ref11;
                                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                    id: "column-".concat(index),
                                    item: true,
                                    xs: 12,
                                    lg: gridItemWidth,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                textAlign: item === null || item === void 0 ? void 0 : (ref = item.primary) === null || ref === void 0 ? void 0 : ref.text_align
                                            },
                                            className: 'step__explication__title',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                data: el.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                textAlign: item === null || item === void 0 ? void 0 : (ref11 = item.primary) === null || ref11 === void 0 ? void 0 : ref11.text_align
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                data: el.text
                                            })
                                        })
                                    ]
                                }, index));
                            })
                        })
                    })
                }, "".concat(item.slice_type, "-").concat(index1)));
            }),
            showVoucherPrintingButton && (takeBack === null || takeBack === void 0 ? void 0 : (ref6 = takeBack.response) === null || ref6 === void 0 ? void 0 : ref6.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "contained",
                    color: "secondary",
                    size: "small",
                    onClick: function() {
                        var ref;
                        return (0,utils/* downloadURI */.l_)(takeBack === null || takeBack === void 0 ? void 0 : (ref = takeBack.response) === null || ref === void 0 ? void 0 : ref.url, "".concat("maje_2ndhand", "_label_second_hand_").concat(orderNumber));
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: takeback === null || takeback === void 0 ? void 0 : (ref7 = takeback.data) === null || ref7 === void 0 ? void 0 : ref7.voucher_printing_button,
                        defaultText: t('texts:takeBack:voucher_printing_button')
                    })
                })
            }),
            (0,CMSText/* isPrismicText */.LT)(takeback === null || takeback === void 0 ? void 0 : (ref8 = takeback.data) === null || ref8 === void 0 ? void 0 : ref8.shop_link_text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: '/shop',
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "contained",
                        color: "secondary",
                        size: "small",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: takeback === null || takeback === void 0 ? void 0 : (ref9 = takeback.data) === null || ref9 === void 0 ? void 0 : ref9.shop_link_text,
                            defaultText: t('texts:takeBack:go_to_shop')
                        })
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var TakeBack_TakeBackThirdStep = ((0,es/* connect */.$j)(TakeBackThirdStep_mapStateToProps, TakeBackThirdStep_mapDispatchToProps)(TakeBackThirdStep));

// EXTERNAL MODULE: ./components/Faq/FaqQuestion.tsx
var FaqQuestion = __webpack_require__(14582);
;// CONCATENATED MODULE: ./components/TakeBack/TakeBackFaq.tsx







var TakeBackFaq = function(param) {
    var takeback = param.takeback, t = param.t;
    var ref3, ref1;
    var classes = TakeBack_style();
    var faqTitle = takeback === null || takeback === void 0 ? void 0 : (ref3 = takeback.data) === null || ref3 === void 0 ? void 0 : ref3.faq_title;
    var faqs = takeback === null || takeback === void 0 ? void 0 : (ref1 = takeback.data) === null || ref1 === void 0 ? void 0 : ref1.q_a;
    var ref2 = (0,react.useState)({
        cat: null,
        question: null
    }), isExpanded = ref2[0], setIsExpanded = ref2[1];
    var handleExpandClick = function(question, cat) {
        setIsExpanded({
            cat: cat,
            question: question
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h3",
                component: "h2",
                className: (0,clsx_m/* default */.Z)('takeBack-faq__title', classes.faqTitle),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    asText: true,
                    data: faqTitle,
                    defaultText: t('texts:takeBack:faq_title')
                })
            }),
            faqs && faqs.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (0,clsx_m/* default */.Z)('takeBack-faq__list', classes.faqList),
                children: faqs === null || faqs === void 0 ? void 0 : faqs.map(function(faq, index) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(FaqQuestion/* default */.Z, {
                        question: faq.question,
                        questionId: index,
                        isExpanded: isExpanded.question === index,
                        handleExpandClick: handleExpandClick,
                        close_others: takeback === null || takeback === void 0 ? void 0 : (ref = takeback.data) === null || ref === void 0 ? void 0 : ref.close_others_on_click,
                        answer: faq.answer
                    }, index);
                })
            })
        ]
    }));
};
/* harmony default export */ var TakeBack_TakeBackFaq = (TakeBackFaq);

// EXTERNAL MODULE: ./redux/actions/prismic.ts
var prismic = __webpack_require__(64063);
;// CONCATENATED MODULE: ./components/TakeBack/takeBackEditParcelNumberStep.tsx







var TakeBackEditParcelNumberStep = function(param) {
    var parcelNumber = param.parcelNumber, onChange = param.onChange, handleNextStep = param.handleNextStep;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var classes = TakeBack_style();
    var ref = (0,react.useState)(''), parcelNumberForm = ref[0], setParcelNumberForm = ref[1];
    var handleSubmit = function(event) {
        event.preventDefault();
        if (!parcelNumber) {
            return;
        }
        handleNextStep === null || handleNextStep === void 0 ? void 0 : handleNextStep();
    };
    var handleChange = function(value) {
        setParcelNumberForm(value);
        onChange(parseInt(value));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: handleSubmit,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)(classes.firstStepFirstPartContainer),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)(classes.marginBottom, classes.parcelNumberContainer),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: t('texts:takeBack:parcel_number_label'),
                        type: "number",
                        value: parcelNumberForm,
                        onChange: handleChange,
                        required: true,
                        min: 1
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)(classes.center, classes.parcelNumberButton),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        size: "small",
                        variant: "contained",
                        color: "primary",
                        type: "submit",
                        className: classes.buttonNextPart,
                        children: t('texts:takeBack:next_step_button')
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var takeBackEditParcelNumberStep = (TakeBackEditParcelNumberStep);

;// CONCATENATED MODULE: ./pages/take-back.tsx
/* provided dependency */ var take_back_process = __webpack_require__(34155);






















function take_back_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return take_back_arrayLikeToArray(arr);
}
function take_back_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function take_back_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                take_back_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                take_back_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function take_back_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function take_back_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            take_back_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || take_back_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function take_back_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return take_back_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return take_back_arrayLikeToArray(o, minLen);
}
var take_back_mapStateToProps = function() {
    return {};
};
var take_back_mapDispatchToProps = {
    postTakeBackInfo: actions_takeBack/* postTakeBackInfo */.cr
};
var TakeBack = function(param) {
    var main = param.main, takeback = param.takeback, inStoreText = param.inStoreText, account = param.account, faqRes = param.faqRes, postTakeBackInfo1 = param.postTakeBackInfo, basket = param.basket, banner = param.banner, funnel = param.funnel, lang = param.lang;
    var ref21, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var classes = TakeBack_style();
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref11 = (0,react.useState)(null), priceValue = ref11[0], setPriceValue = ref11[1];
    var ref12 = (0,react.useState)(1), parcelNumber1 = ref12[0], setParcelNumber = ref12[1];
    var ref13 = (0,react.useState)(0), currentProductIndex = ref13[0], setCurrentProductIndex = ref13[1];
    var ref14 = (0,react.useState)([]), takeBackProductsInformations = ref14[0], setTakeBackProductsInformations = ref14[1];
    var trackPageView = (0,useMatomo/* default */.Z)().trackPageView;
    var ref15 = (0,react.useState)(true), show = ref15[0], setShow = ref15[1];
    var ref16 = (0,react.useState)(false), showCriterion = ref16[0], setShowCriterion = ref16[1];
    var ref17 = (0,react.useState)(false), showLoginForm = ref17[0], setShowLoginForm = ref17[1];
    var ref18 = (0,react.useState)(false), isUpdateStep1 = ref18[0], setIsUpdateStep1 = ref18[1];
    var ref19 = (0,react.useState)(false), secondStepError = ref19[0], setSecondStepError = ref19[1];
    var ref20 = (0,react.useState)(0), activeStep = ref20[0], setActiveStep = ref20[1];
    (0,react.useEffect)(function() {
        var ref;
        if (!(takeback === null || takeback === void 0 ? void 0 : (ref = takeback.data) === null || ref === void 0 ? void 0 : ref.is_take_back_activated)) {
            router.push('/');
        }
        trackPageView({
            documentTitle: 'Take Back Program'
        });
        window === null || window === void 0 ? void 0 : window.scrollTo(0, 0);
    }, []);
    (0,react.useEffect)(function() {
        dispatch((0,prismic/* SAVE_PRISMIC_DOCUMENTS */.w)({
            general: main === null || main === void 0 ? void 0 : main.data,
            account: account === null || account === void 0 ? void 0 : account.data
        }));
    }, [
        account,
        main
    ]);
    //mount, make first product
    (0,react.useEffect)(function() {
        var ref;
        var questionsArray = [];
        takeback === null || takeback === void 0 ? void 0 : (ref = takeback.data) === null || ref === void 0 ? void 0 : ref.questions.forEach(function(question) {
            questionsArray.push({
                title: (0,CMSText/* prismicText */.yz)(question === null || question === void 0 ? void 0 : question.question),
                required: question.is_required,
                answer: ''
            });
        });
        handleTakeBackProductsInformations(true, false, questionsArray);
    }, [
        currentProductIndex,
        isUpdateStep1
    ]);
    var currentLocale = (router === null || router === void 0 ? void 0 : router.locale) ? router.locale : 'fr';
    var formattedCurrentLocale = "".concat(currentLocale, "_").concat(currentLocale.toUpperCase());
    var nextStep = activeStep + 1;
    var handleParcelNumberChange = function(parcelNumber) {
        setParcelNumber(parcelNumber);
    };
    var productStateObject = {
        perfectCondition: {
            title: (0,CMSText/* prismicText */.yz)(takeback === null || takeback === void 0 ? void 0 : (ref21 = takeback.data) === null || ref21 === void 0 ? void 0 : ref21.perfectcondition, t('texts:takeBack:state_1')),
            desc: (0,CMSText/* prismicText */.yz)(takeback === null || takeback === void 0 ? void 0 : (ref1 = takeback.data) === null || ref1 === void 0 ? void 0 : ref1.perfectconditiondefinition, t('texts:takeBack:state_1'))
        },
        veryGoodCondition: {
            title: (0,CMSText/* prismicText */.yz)(takeback === null || takeback === void 0 ? void 0 : (ref2 = takeback.data) === null || ref2 === void 0 ? void 0 : ref2.verygoodcondition, t('texts:takeBack:state_2')),
            desc: (0,CMSText/* prismicText */.yz)(takeback === null || takeback === void 0 ? void 0 : (ref3 = takeback.data) === null || ref3 === void 0 ? void 0 : ref3.verygoodconditiondefinition, t('texts:takeBack:state_2'))
        },
        goodCondition: {
            title: (0,CMSText/* prismicText */.yz)(takeback === null || takeback === void 0 ? void 0 : (ref4 = takeback.data) === null || ref4 === void 0 ? void 0 : ref4.goodcondition, t('texts:takeBack:state_3')),
            desc: (0,CMSText/* prismicText */.yz)(takeback === null || takeback === void 0 ? void 0 : (ref5 = takeback.data) === null || ref5 === void 0 ? void 0 : ref5.goodconditiondefinition, t('texts:takeBack:state_3'))
        }
    };
    var handleNextStep = function() {
        setActiveStep(nextStep);
    };
    var handlePrevStep = function() {
        if (activeStep === 0 && show === false) {
            setShow(true);
        }
        if (activeStep === 0 && show === false) {
            setShow(true);
        }
        if (activeStep === 1 && showLoginForm === false) {
            setActiveStep(activeStep - 1);
            setShow(false);
            setShowCriterion(true);
        }
        if (activeStep === 1 && showLoginForm === true) {
            setShowLoginForm(false);
        }
    };
    var handleAddProduct = function() {
        var newIndex = takeBackProductsInformations.length;
        setCurrentProductIndex(newIndex);
        setActiveStep(0);
        setShow(true);
        setShowCriterion(false);
        setIsUpdateStep1(!isUpdateStep1);
    };
    var handleRemoveProduct = function(index) {
        var productList = _toConsumableArray(takeBackProductsInformations);
        productList.splice(index, 1);
        setTakeBackProductsInformations(productList);
    };
    // storage of product informations at each step in order to reuse them:
    // pre-filled forms on previous step
    // send informations with handleLogisticsTakeBackData
    var handleTakeBackProductsInformations = function(firstStepFirstPart, firstStepSecondPart, productData) {
        var takeBackProducts = _toConsumableArray(takeBackProductsInformations);
        if (firstStepFirstPart) {
            if (takeBackProducts[currentProductIndex]) {
                takeBackProducts[currentProductIndex] = take_back_objectSpread({}, takeBackProducts[currentProductIndex], {
                    answers: productData
                });
            } else {
                takeBackProducts.push({
                    answers: productData
                });
            }
        }
        if (firstStepSecondPart) {
            takeBackProducts[currentProductIndex] = take_back_objectSpread({}, takeBackProducts[currentProductIndex], productData);
        }
        setTakeBackProductsInformations(takeBackProducts);
    };
    //add type for takeBackCustomerData and currentIncentive
    var handleLogisticsTakeBackData = function() {
        var _ref = take_back_asyncToGenerator(runtime_default().mark(function _callee(takeBackCustomerData, currentIncentive) {
            var products, logisticsTakeBackData, postTakeBackRequest;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        products = [];
                        takeBackProductsInformations.map(function(product) {
                            var amount = parseFloat((product.amount + product.amount * currentIncentive / 100).toFixed(0));
                            products.push({
                                lizeeSKU: product.lizeeSKU,
                                labelReference: product.labelReference,
                                amount: amount,
                                quality: product.quality,
                                withoutLabelReference: product.withoutLabelReference
                            });
                        });
                        logisticsTakeBackData = take_back_objectSpread({
                            products: products,
                            parcelNumber: parcelNumber1,
                            carrierId: parseInt((0,utils/* secondHandCarrierIdByCountry */.cy)(takeBackCustomerData === null || takeBackCustomerData === void 0 ? void 0 : takeBackCustomerData.country))
                        }, takeBackCustomerData);
                        _ctx.next = 5;
                        return postTakeBackInfo1(logisticsTakeBackData);
                    case 5:
                        postTakeBackRequest = _ctx.sent;
                        if (postTakeBackRequest.type === 'POST_TAKE_BACK_INFO_SUCCESS') {
                            handleNextStep();
                        } else {
                            setSecondStepError(true);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLogisticsTakeBackData(takeBackCustomerData, currentIncentive) {
            return _ref.apply(this, arguments);
        };
    }();
    var Steps = (0,react.useMemo)(function() {
        var ref, ref22;
        var steps = [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_TakeBackFirstStep, {
                handleNextStep: handleNextStep,
                prismicTakeBack: takeback,
                t: t,
                priceValue: priceValue,
                setPriceValue: setPriceValue,
                handleTakeBackProductsInformations: handleTakeBackProductsInformations,
                show: show,
                setShow: setShow,
                takeBackProductsInformations: takeBackProductsInformations,
                currentProductIndex: currentProductIndex,
                showCriterion: showCriterion,
                setShowCriterion: setShowCriterion,
                productStateObject: productStateObject,
                main: main,
                lang: lang
            }, "first-step"), 
        ];
        if (takeback === null || takeback === void 0 ? void 0 : (ref = takeback.data) === null || ref === void 0 ? void 0 : ref.show_edit_parcel_number) {
            steps.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(takeBackEditParcelNumberStep, {
                parcelNumber: parcelNumber1,
                onChange: handleParcelNumberChange,
                handleNextStep: handleNextStep
            }, "parcel-edit"));
        }
        steps.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_TakeBackSecondStep, {
            takeback: takeback,
            t: t,
            account: account,
            takeBackProductsInformations: takeBackProductsInformations,
            priceValue: priceValue,
            handleRemoveProduct: handleRemoveProduct,
            handleAddProduct: handleAddProduct,
            handleLogisticsTakeBackData: handleLogisticsTakeBackData,
            formattedCurrentLocale: formattedCurrentLocale,
            productStateObject: productStateObject,
            showLoginForm: showLoginForm,
            setShowLoginForm: setShowLoginForm,
            main: main,
            secondStepError: secondStepError,
            funnel: funnel
        }, "second-step"));
        steps.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_TakeBackThirdStep, {
            takeback: takeback,
            t: t,
            showVoucherPrintingButton: takeback === null || takeback === void 0 ? void 0 : (ref22 = takeback.data) === null || ref22 === void 0 ? void 0 : ref22.show_voucher_printing_button
        }, "third-step"));
        return steps;
    }, [
        takeback,
        t,
        account,
        priceValue,
        takeBackProductsInformations,
        handleNextStep,
        handleRemoveProduct,
        handleAddProduct,
        handleLogisticsTakeBackData,
        showLoginForm,
        currentProductIndex,
        show,
        showCriterion,
        formattedCurrentLocale,
        productStateObject,
        secondStepError,
        main,
        lang, 
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        mainLogo: main === null || main === void 0 ? void 0 : (ref6 = main.data) === null || ref6 === void 0 ? void 0 : ref6.logo,
        doc: main,
        metaTitle: (0,CMSText/* prismicText */.yz)(takeback === null || takeback === void 0 ? void 0 : (ref7 = takeback.data) === null || ref7 === void 0 ? void 0 : ref7.meta_title_take_back, t('texts:takeBack:meta_title')),
        hideTop: true,
        inStoreText: inStoreText,
        t: t,
        metaDescription: takeback === null || takeback === void 0 ? void 0 : (ref8 = takeback.data) === null || ref8 === void 0 ? void 0 : ref8.meta_description_take_back,
        metaKeywords: takeback === null || takeback === void 0 ? void 0 : (ref9 = takeback.data) === null || ref9 === void 0 ? void 0 : ref9.meta_keywords_take_back,
        basket: basket,
        takeback: takeback,
        account: account,
        faq: faqRes,
        banner: banner,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
            className: (0,clsx_m/* default */.Z)('takeBack', classes.root),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: 'xl',
                className: (0,clsx_m/* default */.Z)('takeBack__container', classes.container),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)('takeBack__content', classes.content),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_TakeBackHeader, {
                            settings: takeback,
                            handlePrevStep: handlePrevStep,
                            t: t,
                            activeStep: activeStep,
                            show: show
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_TakeBackBox, {
                            data: takeback === null || takeback === void 0 ? void 0 : takeback.data,
                            t: t,
                            activeStep: activeStep,
                            hideStep2: !!take_back_process.env.SIMPLIFIED_TAKE_BACK,
                            additionalEditParcelNumberStep: takeback === null || takeback === void 0 ? void 0 : (ref10 = takeback.data) === null || ref10 === void 0 ? void 0 : ref10.show_edit_parcel_number,
                            children: Steps[activeStep]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)(classes.faqSection, 'takeBack-faq__section'),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_TakeBackFaq, {
                                takeback: takeback,
                                t: t
                            })
                        })
                    ]
                })
            })
        })
    }));
};
var __N_SSG = true;
/* harmony default export */ var take_back = ((0,es/* connect */.$j)(take_back_mapStateToProps, take_back_mapDispatchToProps)(TakeBack));


/***/ }),

/***/ 78101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Kn": function() { return /* binding */ addressUser_getAddress; },
  "Pe": function() { return /* binding */ addressUser_patchAddress; },
  "L4": function() { return /* binding */ addressUser_postAddress; },
  "EJ": function() { return /* binding */ addressUser_putAddress; }
});

// UNUSED EXPORTS: ACTIONS, GET_ADDRESS_USER_FAILURE, GET_ADDRESS_USER_REQUEST, GET_ADDRESS_USER_SUCCESS, PATCH_ADDRESS_USER_FAILURE, PATCH_ADDRESS_USER_REQUEST, PATCH_ADDRESS_USER_SUCCESS, POST_ADDRESS_USER_FAILURE, POST_ADDRESS_USER_REQUEST, POST_ADDRESS_USER_SUCCESS, PUT_ADDRESS_USER_FAILURE, PUT_ADDRESS_USER_REQUEST, PUT_ADDRESS_USER_SUCCESS

// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/addressUser.ts




var getAddress = function() {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.address */.KU.address,
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE))
    });
};
var postAddress = function(data) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* ERequestUrl.address */.KU.address,
        data: data,
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE))
    });
};
var putAddress = function(data, id) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.put */.YZ.put,
        url: requests/* ERequestUrl.address */.KU.address,
        data: data,
        uid: id.toString(),
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE))
    });
};
var patchAddress = function(id) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.patch */.YZ.patch,
        url: requests/* ERequestUrl.address */.KU.address,
        uid: "".concat(id.toString(), "/default"),
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE))
    });
};

;// CONCATENATED MODULE: ./redux/actions/addressUser.ts

var ACTIONS = {
    GET_ADDRESS_USER_REQUEST: 'GET_ADDRESS_USER_REQUEST',
    GET_ADDRESS_USER_SUCCESS: 'GET_ADDRESS_USER_SUCCESS',
    GET_ADDRESS_USER_FAILURE: 'GET_ADDRESS_USER_FAILURE',
    POST_ADDRESS_USER_REQUEST: 'POST_ADDRESS_USER_REQUEST',
    POST_ADDRESS_USER_SUCCESS: 'POST_ADDRESS_USER_SUCCESS',
    POST_ADDRESS_USER_FAILURE: 'POST_ADDRESS_USER_FAILURE',
    PUT_ADDRESS_USER_REQUEST: 'PUT_ADDRESS_USER_REQUEST',
    PUT_ADDRESS_USER_SUCCESS: 'PUT_ADDRESS_USER_SUCCESS',
    PUT_ADDRESS_USER_FAILURE: 'PUT_ADDRESS_USER_FAILURE',
    PATCH_ADDRESS_USER_REQUEST: 'PATCH_ADDRESS_USER_REQUEST',
    PATCH_ADDRESS_USER_SUCCESS: 'PATCH_ADDRESS_USER_SUCCESS',
    PATCH_ADDRESS_USER_FAILURE: 'PATCH_ADDRESS_USER_FAILURE'
};
var GET_ADDRESS_USER_REQUEST = function() {
    return {
        type: ACTIONS.GET_ADDRESS_USER_REQUEST
    };
};
var GET_ADDRESS_USER_SUCCESS = function(address) {
    return {
        type: ACTIONS.GET_ADDRESS_USER_SUCCESS,
        address: address
    };
};
var GET_ADDRESS_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_ADDRESS_USER_FAILURE,
        err: err
    };
};
function addressUser_getAddress() {
    return function(dispatch) {
        dispatch(GET_ADDRESS_USER_REQUEST());
        return getAddress().then(function(response) {
            return dispatch(GET_ADDRESS_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_ADDRESS_USER_FAILURE(err));
        });
    };
}
var POST_ADDRESS_USER_REQUEST = function() {
    return {
        type: ACTIONS.POST_ADDRESS_USER_REQUEST
    };
};
var POST_ADDRESS_USER_SUCCESS = function(address) {
    return {
        type: ACTIONS.POST_ADDRESS_USER_SUCCESS,
        address: address
    };
};
var POST_ADDRESS_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.POST_ADDRESS_USER_FAILURE,
        err: err
    };
};
function addressUser_postAddress(data) {
    return function(dispatch) {
        dispatch(POST_ADDRESS_USER_REQUEST());
        return postAddress(data).then(function(response) {
            return dispatch(POST_ADDRESS_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(POST_ADDRESS_USER_FAILURE(err));
        });
    };
}
var PUT_ADDRESS_USER_REQUEST = function() {
    return {
        type: ACTIONS.PUT_ADDRESS_USER_REQUEST
    };
};
var PUT_ADDRESS_USER_SUCCESS = function(address) {
    return {
        type: ACTIONS.PUT_ADDRESS_USER_SUCCESS,
        address: address
    };
};
var PUT_ADDRESS_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.PUT_ADDRESS_USER_FAILURE,
        err: err
    };
};
function addressUser_putAddress(data, id) {
    return function(dispatch) {
        dispatch(PUT_ADDRESS_USER_REQUEST());
        return putAddress(data, id).then(function(response) {
            return dispatch(PUT_ADDRESS_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(PUT_ADDRESS_USER_FAILURE(err));
        });
    };
}
var PATCH_ADDRESS_USER_REQUEST = function() {
    return {
        type: ACTIONS.PATCH_ADDRESS_USER_REQUEST
    };
};
var PATCH_ADDRESS_USER_SUCCESS = function(address) {
    return {
        type: ACTIONS.PATCH_ADDRESS_USER_SUCCESS,
        address: address
    };
};
var PATCH_ADDRESS_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.PATCH_ADDRESS_USER_FAILURE,
        err: err
    };
};
function addressUser_patchAddress(id) {
    return function(dispatch) {
        dispatch(PATCH_ADDRESS_USER_REQUEST());
        return patchAddress(id).then(function(response) {
            return dispatch(PATCH_ADDRESS_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(PATCH_ADDRESS_USER_FAILURE(err));
        });
    };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [282,2215,15350,79593,366,57443,94108,76192,24951,47533,24282,72979,51656,60502,19789,95188,48884,35214,29660,93166,49774,92888,40179], function() { return __webpack_exec__(29761); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);